import { SankeyLink } from '../types/sankey';

export const ClusterFour: SankeyLink[] = [
    {
        cluster: 'cluster4',
        source: 146,
        target: 23,
        value: 1,
        valueid: 'repb',
        paperName: 'GYS14',
        process: 'GYS14_8',
        id: 'GYS14-61',
        imgUrl: 'r9tEkOr.jpg',
        color: 'targetLinkFourColor',
    },
    {
        cluster: 'cluster4',
        source: 46,
        target: 70,
        value: 1,
        valueid: 'repb',
        paperName: 'GYS14',
        process: 'GYS14_8',
        id: 'GYS14-63',
        imgUrl: 'r9tEkOr.jpg',
        color: 'intFiveLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 23,
        target: 46,
        value: 1,
        valueid: 'repb',
        paperName: 'GYS14',
        process: 'GYS14_8',
        id: 'GYS14-62',
        imgUrl: 'r9tEkOr.jpg',
        color: 'intFiveLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 70,
        target: 98,
        value: 1,
        valueid: 'repb',
        paperName: 'GYS14',
        process: 'GYS14_3',
        id: 'GYS14-63',
        imgUrl: 'r9tEkOr.jpg',
        color: 'repVisTechColor',
    },
    {
        cluster: 'cluster4',
        source: 70,
        target: 98,
        value: 1,
        valueid: 'repb',
        paperName: 'GYS14',
        process: 'GYS14_7',
        id: 'GYS14-63',
        imgUrl: 'r9tEkOr.jpg',
        color: 'repVisTechColor',
    },
    {
        cluster: 'cluster4',
        source: 70,
        target: 98,
        value: 1,
        valueid: 'repb',
        paperName: 'GYS14',
        process: 'GYS14_8',
        id: 'GYS14-63',
        imgUrl: 'r9tEkOr.jpg',
        color: 'repVisTechColor',
    },
    {
        cluster: 'cluster4',
        source: 100,
        target: 11,
        value: 1,
        valueid: ['repb', 'targetaa'],
        paperName: 'CAA20',
        process: 'CAA20_4',
        id: 'CAA20-3',
        imgUrl: 'DFBi3Mo.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 100,
        target: 12,
        value: 1,
        valueid: ['repb', 'targetaa'],
        paperName: 'CAA20',
        process: 'CAA20_5',
        id: 'CAA20-4',
        imgUrl: 'DFBi3Mo.jpg',
        color: 'targetLinkTwoColor',
    },
    { cluster: 'cluster4', source: 11, target: 45, value: 1, valueid: ['repb', 'targetaa'], paperName: 'CAA20', process: 'CAA20_4', id: 'CAA20-10', imgUrl: 'DFBi3Mo.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 12, target: 45, value: 1, valueid: ['repb', 'targetaa'], paperName: 'CAA20', process: 'CAA20_5', id: 'CAA20-11', imgUrl: 'DFBi3Mo.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 45, target: 54, value: 1, valueid: ['repb', 'targetaa'], paperName: 'CAA20', process: 'CAA20_4', id: 'CAA20-17', imgUrl: 'DFBi3Mo.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 45, target: 54, value: 1, valueid: ['repb', 'targetaa'], paperName: 'CAA20', process: 'CAA20_5', id: 'CAA20-18', imgUrl: 'DFBi3Mo.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 54, target: 77, value: 1, valueid: ['repb', 'targetaa'], paperName: 'CAA20', process: 'CAA20_4', id: 'CAA20-24', imgUrl: 'DFBi3Mo.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 54, target: 78, value: 1, valueid: ['repb', 'targetaa'], paperName: 'CAA20', process: 'CAA20_4', id: 'CAA20-25', imgUrl: 'DFBi3Mo.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 54, target: 92, value: 1, valueid: ['repb', 'targetaa'], paperName: 'CAA20', process: 'CAA20_4', id: 'CAA20-26', imgUrl: 'DFBi3Mo.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 54, target: 92, value: 1, valueid: ['repb', 'targetaa'], paperName: 'CAA20', process: 'CAA20_5', id: 'CAA20-27', imgUrl: 'DFBi3Mo.jpg', color: 'repVisTechColor' },
    {
        cluster: 'cluster4',
        source: 102,
        target: 11,
        value: 1,
        valueid: ['targetab', 'targetca', 'repc'],
        paperName: 'CSL12',
        process: 'CSL12_1',
        id: 'CSL12-0',
        imgUrl: 'a3kehFc.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 102,
        target: 12,
        value: 1,
        valueid: ['targetab', 'targetca', 'repc'],
        paperName: 'CSL12',
        process: 'CSL12_1',
        id: 'CSL12-2',
        imgUrl: 'a3kehFc.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 11,
        target: 45,
        value: 1,
        valueid: ['targetab', 'targetca', 'repc'],
        paperName: 'CSL12',
        process: 'CSL12_1',
        id: 'CSL12-13',
        imgUrl: 'a3kehFc.jpg',
        color: 'intFourLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 12,
        target: 45,
        value: 1,
        valueid: ['targetab', 'targetca', 'repc'],
        paperName: 'CSL12',
        process: 'CSL12_1',
        id: 'CSL12-14',
        imgUrl: 'a3kehFc.jpg',
        color: 'intFourLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 45,
        target: 53,
        value: 1,
        valueid: ['targetab', 'targetca', 'repc'],
        paperName: 'CSL12',
        process: 'CSL12_1',
        id: 'CSL12-26',
        imgUrl: 'a3kehFc.jpg',
        color: 'intFourLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 53,
        target: 77,
        value: 1,
        valueid: ['targetab', 'targetca', 'repc'],
        paperName: 'CSL12',
        process: 'CSL12_1',
        id: 'CSL12-33',
        imgUrl: 'a3kehFc.jpg',
        color: 'repVisVarColor',
    },
    { cluster: 'cluster4', source: 106, target: 5, value: 1, valueid: ['targetbb', 'reph'], paperName: 'FCF09', process: 'FCF09_3', id: 'FCF09-6', imgUrl: 'FfzA9S4.png', color: 'targetLinkColor' },
    {
        cluster: 'cluster4',
        source: 106,
        target: 17,
        value: 1,
        valueid: ['targetbb', 'reph'],
        paperName: 'FCF09',
        process: 'FCF09_3',
        id: 'FCF09-7',
        imgUrl: 'FfzA9S4.png',
        color: 'targetLinkThreeColor',
    },
    {
        cluster: 'cluster4',
        source: 106,
        target: 18,
        value: 1,
        valueid: ['targetbb', 'reph'],
        paperName: 'FCF09',
        process: 'FCF09_3',
        id: 'FCF09-8',
        imgUrl: 'FfzA9S4.png',
        color: 'targetLinkThreeColor',
    },
    { cluster: 'cluster4', source: 5, target: 45, value: 1, valueid: ['targetbb', 'reph'], paperName: 'FCF09', process: 'FCF09_3', id: 'FCF09-12', imgUrl: 'FfzA9S4.png', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 17, target: 45, value: 1, valueid: ['targetbb', 'reph'], paperName: 'FCF09', process: 'FCF09_3', id: 'FCF09-15', imgUrl: 'FfzA9S4.png', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 18, target: 45, value: 1, valueid: ['targetbb', 'reph'], paperName: 'FCF09', process: 'FCF09_3', id: 'FCF09-18', imgUrl: 'FfzA9S4.png', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 45, target: 62, value: 1, valueid: ['targetbb', 'reph'], paperName: 'FCF09', process: 'FCF09_3', id: 'FCF09-22', imgUrl: 'FfzA9S4.png', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 62, target: 77, value: 1, valueid: ['targetbb', 'reph'], paperName: 'FCF09', process: 'FCF09_3', id: 'FCF09-26', imgUrl: 'FfzA9S4.png', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 62, target: 79, value: 1, valueid: ['targetbb', 'reph'], paperName: 'FCF09', process: 'FCF09_3', id: 'FCF09-28', imgUrl: 'FfzA9S4.png', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 62, target: 80, value: 1, valueid: ['targetbb', 'reph'], paperName: 'FCF09', process: 'FCF09_3', id: 'FCF09-30', imgUrl: 'FfzA9S4.png', color: 'repVisVarColor' },
    {
        cluster: 'cluster4',
        source: 107,
        target: 3,
        value: 1,
        valueid: ['targetbb', 'repc'],
        paperName: 'GGS12MT',
        process: 'GGS12MT_1',
        id: 'GGS12MT-0',
        imgUrl: 'wVHfoIB.png',
        color: 'targetLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 107,
        target: 12,
        value: 1,
        valueid: ['targetbb', 'repc'],
        paperName: 'GGS12MT',
        process: 'GGS12MT_1',
        id: 'GGS12MT-1',
        imgUrl: 'wVHfoIB.png',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 3,
        target: 45,
        value: 1,
        valueid: ['targetbb', 'repc'],
        paperName: 'GGS12MT',
        process: 'GGS12MT_1',
        id: 'GGS12MT-6',
        imgUrl: 'wVHfoIB.png',
        color: 'intFourLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 12,
        target: 45,
        value: 1,
        valueid: ['targetbb', 'repc'],
        paperName: 'GGS12MT',
        process: 'GGS12MT_1',
        id: 'GGS12MT-8',
        imgUrl: 'wVHfoIB.png',
        color: 'intFourLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 45,
        target: 53,
        value: 1,
        valueid: ['targetbb', 'repc'],
        paperName: 'GGS12MT',
        process: 'GGS12MT_1',
        id: 'GGS12MT-14',
        imgUrl: 'wVHfoIB.png',
        color: 'intFourLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 53,
        target: 77,
        value: 1,
        valueid: ['targetbb', 'repc'],
        paperName: 'GGS12MT',
        process: 'GGS12MT_1',
        id: 'GGS12MT-16',
        imgUrl: 'wVHfoIB.png',
        color: 'repVisVarColor',
    },
    {
        cluster: 'cluster4',
        source: 108,
        target: 3,
        value: 1,
        valueid: ['repea', 'targetbb'],
        paperName: 'GGS12ST',
        process: 'GGS12ST_1',
        id: 'GGS12ST-0',
        imgUrl: 'HV2lNkC.png',
        color: 'targetLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 108,
        target: 12,
        value: 1,
        valueid: ['repeb', 'targetbb'],
        paperName: 'GGS12ST',
        process: 'GGS12ST_2',
        id: 'GGS12ST-1',
        imgUrl: 'HV2lNkC.png',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 3,
        target: 45,
        value: 1,
        valueid: ['repea', 'targetbb'],
        paperName: 'GGS12ST',
        process: 'GGS12ST_1',
        id: 'GGS12ST-3',
        imgUrl: 'HV2lNkC.png',
        color: 'intFourLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 12,
        target: 45,
        value: 1,
        valueid: ['repeb', 'targetbb'],
        paperName: 'GGS12ST',
        process: 'GGS12ST_2',
        id: 'GGS12ST-5',
        imgUrl: 'HV2lNkC.png',
        color: 'intFourLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 45,
        target: 59,
        value: 1,
        valueid: ['repea', 'targetbb'],
        paperName: 'GGS12ST',
        process: 'GGS12ST_1',
        id: 'GGS12ST-9',
        imgUrl: 'HV2lNkC.png',
        color: 'intFourLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 45,
        target: 59,
        value: 1,
        valueid: ['repeb', 'targetbb'],
        paperName: 'GGS12ST',
        process: 'GGS12ST_2',
        id: 'GGS12ST-10',
        imgUrl: 'HV2lNkC.png',
        color: 'intFourLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 59,
        target: 77,
        value: 1,
        valueid: ['repea', 'targetbb'],
        paperName: 'GGS12ST',
        process: 'GGS12ST_1',
        id: 'GGS12ST-12',
        imgUrl: 'HV2lNkC.png',
        color: 'repVisVarColor',
    },
    {
        cluster: 'cluster4',
        source: 59,
        target: 77,
        value: 1,
        valueid: ['repeb', 'targetbb'],
        paperName: 'GGS12ST',
        process: 'GGS12ST_2',
        id: 'GGS12ST-13',
        imgUrl: 'HV2lNkC.png',
        color: 'repVisVarColor',
    },
    {
        cluster: 'cluster4',
        source: 113,
        target: 11,
        value: 1,
        valueid: ['targetba', 'targetbb'],
        paperName: 'JX17',
        process: 'JX17_6',
        id: 'JX17-8',
        imgUrl: 'dbYhmdg.jpg',
        color: 'targetLinkTwoColor',
    },
    { cluster: 'cluster4', source: 11, target: 45, value: 1, valueid: ['targetba', 'targetbb'], paperName: 'JX17', process: 'JX17_6', id: 'JX17-18', imgUrl: 'dbYhmdg.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 45, target: 65, value: 1, valueid: ['targetba', 'targetbb'], paperName: 'JX17', process: 'JX17_6', id: 'JX17-25', imgUrl: 'dbYhmdg.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 65, target: 92, value: 1, valueid: ['targetba', 'targetbb'], paperName: 'JX17', process: 'JX17_6', id: 'JX17-33', imgUrl: 'dbYhmdg.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 65, target: 77, value: 1, valueid: ['targetba', 'targetbb'], paperName: 'JX17', process: 'JX17_6', id: 'JX17-36', imgUrl: 'dbYhmdg.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 65, target: 78, value: 1, valueid: ['targetba', 'targetbb'], paperName: 'JX17', process: 'JX17_6', id: 'JX17-37', imgUrl: 'dbYhmdg.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 115, target: 11, value: 1, valueid: 'repea ', paperName: 'LGX16', process: 'LGX16_4', id: 'LGX16-3', imgUrl: 'WcypLMa.png', color: 'targetLinkTwoColor' },
    { cluster: 'cluster4', source: 115, target: 12, value: 1, valueid: 'repea ', paperName: 'LGX16', process: 'LGX16_4', id: 'LGX16-4', imgUrl: 'WcypLMa.png', color: 'targetLinkTwoColor' },
    { cluster: 'cluster4', source: 115, target: 17, value: 1, valueid: 'repg ', paperName: 'LGX16', process: 'LGX16_5', id: 'LGX16-5', imgUrl: 'WcypLMa.png', color: 'targetLinkThreeColor' },
    { cluster: 'cluster4', source: 115, target: 19, value: 1, valueid: 'repg ', paperName: 'LGX16', process: 'LGX16_5', id: 'LGX16-6', imgUrl: 'WcypLMa.png', color: 'targetLinkThreeColor' },
    { cluster: 'cluster4', source: 11, target: 45, value: 1, valueid: 'repea ', paperName: 'LGX16', process: 'LGX16_4', id: 'LGX16-11', imgUrl: 'WcypLMa.png', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 12, target: 45, value: 1, valueid: 'repea ', paperName: 'LGX16', process: 'LGX16_4', id: 'LGX16-13', imgUrl: 'WcypLMa.png', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 17, target: 45, value: 1, valueid: 'repg ', paperName: 'LGX16', process: 'LGX16_5', id: 'LGX16-14', imgUrl: 'WcypLMa.png', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 19, target: 45, value: 1, valueid: 'repg ', paperName: 'LGX16', process: 'LGX16_5', id: 'LGX16-15', imgUrl: 'WcypLMa.png', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 45, target: 59, value: 1, valueid: 'repea', paperName: 'LGX16', process: 'LGX16_4', id: 'LGX16-20', imgUrl: 'WcypLMa.png', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 45, target: 68, value: 1, valueid: 'repg', paperName: 'LGX16', process: 'LGX16_5', id: 'LGX16-21', imgUrl: 'WcypLMa.png', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 59, target: 76, value: 1, valueid: 'repea ', paperName: 'LGX16', process: 'LGX16_4', id: 'LGX16-28', imgUrl: 'WcypLMa.png', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 59, target: 77, value: 1, valueid: 'repea ', paperName: 'LGX16', process: 'LGX16_4', id: 'LGX16-29', imgUrl: 'WcypLMa.png', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 59, target: 80, value: 1, valueid: 'repea ', paperName: 'LGX16', process: 'LGX16_4', id: 'LGX16-30', imgUrl: 'WcypLMa.png', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 68, target: 80, value: 1, valueid: 'repg ', paperName: 'LGX16', process: 'LGX16_5', id: 'LGX16-31', imgUrl: 'WcypLMa.png', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 116, target: 3, value: 1, valueid: 'repb', paperName: 'LJC18', process: 'LJC18_2', id: 'LJC18-2', imgUrl: 'bYdgkcY.jpg', color: 'targetLinkColor' },
    { cluster: 'cluster4', source: 116, target: 11, value: 1, valueid: 'repb', paperName: 'LJC18', process: 'LJC18_6', id: 'LJC18-5', imgUrl: 'bYdgkcY.jpg', color: 'targetLinkTwoColor' },
    { cluster: 'cluster4', source: 3, target: 45, value: 1, valueid: 'repb', paperName: 'LJC18', process: 'LJC18_2', id: 'LJC18-10', imgUrl: 'bYdgkcY.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 11, target: 45, value: 1, valueid: 'repb', paperName: 'LJC18', process: 'LJC18_6', id: 'LJC18-12', imgUrl: 'bYdgkcY.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 45, target: 54, value: 1, valueid: 'repb', paperName: 'LJC18', process: 'LJC18_2', id: 'LJC18-21', imgUrl: 'bYdgkcY.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 45, target: 54, value: 1, valueid: 'repb', paperName: 'LJC18', process: 'LJC18_6', id: 'LJC18-22', imgUrl: 'bYdgkcY.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 54, target: 77, value: 1, valueid: 'repb', paperName: 'LJC18', process: 'LJC18_2', id: 'LJC18-29', imgUrl: 'bYdgkcY.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 54, target: 77, value: 1, valueid: 'repb', paperName: 'LJC18', process: 'LJC18_6', id: 'LJC18-31', imgUrl: 'bYdgkcY.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 54, target: 92, value: 1, valueid: 'repb', paperName: 'LJC18', process: 'LJC18_2', id: 'LJC18-35', imgUrl: 'bYdgkcY.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 54, target: 92, value: 1, valueid: 'repb', paperName: 'LJC18', process: 'LJC18_6', id: 'LJC18-37', imgUrl: 'bYdgkcY.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 54, target: 98, value: 1, valueid: 'repb', paperName: 'LJC18', process: 'LJC18_2', id: 'LJC18-38', imgUrl: 'bYdgkcY.jpg', color: 'repVisTechColor' },
    {
        cluster: 'cluster4',
        source: 121,
        target: 11,
        value: 1,
        valueid: ['targetaa', 'repd'],
        paperName: 'MEV16',
        process: 'MEV16_2',
        id: 'MEV16-1',
        imgUrl: 'FpTZ8Nt.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 121,
        target: 13,
        value: 1,
        valueid: ['targetaa', 'repd'],
        paperName: 'MEV16',
        process: 'MEV16_2',
        id: 'MEV16-2',
        imgUrl: 'FpTZ8Nt.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 121,
        target: 11,
        value: 1,
        valueid: ['targetaa', 'repf'],
        paperName: 'MEV16',
        process: 'MEV16_3',
        id: 'MEV16-3',
        imgUrl: 'FpTZ8Nt.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 121,
        target: 13,
        value: 1,
        valueid: ['targetaa', 'repf'],
        paperName: 'MEV16',
        process: 'MEV16_3',
        id: 'MEV16-4',
        imgUrl: 'FpTZ8Nt.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 121,
        target: 18,
        value: 1,
        valueid: ['targetaa', 'repd'],
        paperName: 'MEV16',
        process: 'MEV16_4',
        id: 'MEV16-5',
        imgUrl: 'FpTZ8Nt.jpg',
        color: 'targetLinkThreeColor',
    },
    {
        cluster: 'cluster4',
        source: 121,
        target: 19,
        value: 1,
        valueid: ['targetaa', 'repd'],
        paperName: 'MEV16',
        process: 'MEV16_4',
        id: 'MEV16-6',
        imgUrl: 'FpTZ8Nt.jpg',
        color: 'targetLinkThreeColor',
    },
    {
        cluster: 'cluster4',
        source: 121,
        target: 18,
        value: 1,
        valueid: ['targetaa', 'repf'],
        paperName: 'MEV16',
        process: 'MEV16_5',
        id: 'MEV16-7',
        imgUrl: 'FpTZ8Nt.jpg',
        color: 'targetLinkThreeColor',
    },
    {
        cluster: 'cluster4',
        source: 121,
        target: 19,
        value: 1,
        valueid: ['targetaa', 'repf'],
        paperName: 'MEV16',
        process: 'MEV16_5',
        id: 'MEV16-8',
        imgUrl: 'FpTZ8Nt.jpg',
        color: 'targetLinkThreeColor',
    },
    { cluster: 'cluster4', source: 11, target: 45, value: 1, valueid: ['targetaa', 'repd'], paperName: 'MEV16', process: 'MEV16_2', id: 'MEV16-14', imgUrl: 'FpTZ8Nt.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 13, target: 45, value: 1, valueid: ['targetaa', 'repd'], paperName: 'MEV16', process: 'MEV16_2', id: 'MEV16-16', imgUrl: 'FpTZ8Nt.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 45, target: 55, value: 1, valueid: ['targetaa', 'repd'], paperName: 'MEV16', process: 'MEV16_2', id: 'MEV16-18', imgUrl: 'FpTZ8Nt.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 55, target: 85, value: 1, valueid: ['targetaa', 'repd'], paperName: 'MEV16', process: 'MEV16_2', id: 'MEV16-19', imgUrl: 'FpTZ8Nt.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 11, target: 45, value: 1, valueid: ['targetaa', 'repf'], paperName: 'MEV16', process: 'MEV16_3', id: 'MEV16-21', imgUrl: 'FpTZ8Nt.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 13, target: 45, value: 1, valueid: ['targetaa', 'repf'], paperName: 'MEV16', process: 'MEV16_3', id: 'MEV16-23', imgUrl: 'FpTZ8Nt.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 45, target: 60, value: 1, valueid: ['targetaa', 'repf'], paperName: 'MEV16', process: 'MEV16_3', id: 'MEV16-25', imgUrl: 'FpTZ8Nt.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 60, target: 85, value: 1, valueid: ['targetaa', 'repf'], paperName: 'MEV16', process: 'MEV16_3', id: 'MEV16-26', imgUrl: 'FpTZ8Nt.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 18, target: 45, value: 1, valueid: ['targetaa', 'repd'], paperName: 'MEV16', process: 'MEV16_4', id: 'MEV16-27', imgUrl: 'FpTZ8Nt.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 19, target: 45, value: 1, valueid: ['targetaa', 'repd'], paperName: 'MEV16', process: 'MEV16_4', id: 'MEV16-28', imgUrl: 'FpTZ8Nt.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 45, target: 55, value: 1, valueid: ['targetaa', 'repd'], paperName: 'MEV16', process: 'MEV16_4', id: 'MEV16-29', imgUrl: 'FpTZ8Nt.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 55, target: 77, value: 1, valueid: ['targetaa', 'repd'], paperName: 'MEV16', process: 'MEV16_4', id: 'MEV16-30', imgUrl: 'FpTZ8Nt.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 18, target: 45, value: 1, valueid: ['targetaa', 'repf'], paperName: 'MEV16', process: 'MEV16_5', id: 'MEV16-31', imgUrl: 'FpTZ8Nt.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 19, target: 45, value: 1, valueid: ['targetaa', 'repf'], paperName: 'MEV16', process: 'MEV16_5', id: 'MEV16-32', imgUrl: 'FpTZ8Nt.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 45, target: 60, value: 1, valueid: ['targetaa', 'repf'], paperName: 'MEV16', process: 'MEV16_5', id: 'MEV16-33', imgUrl: 'FpTZ8Nt.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 60, target: 77, value: 1, valueid: ['targetaa', 'repf'], paperName: 'MEV16', process: 'MEV16_5', id: 'MEV16-34', imgUrl: 'FpTZ8Nt.jpg', color: 'repVisVarColor' },
    {
        cluster: 'cluster4',
        source: 122,
        target: 11,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'MHK16',
        process: 'MHK16_1',
        id: 'MHK16-0',
        imgUrl: 'Ak8KSur.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 122,
        target: 12,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'MHK16',
        process: 'MHK16_1',
        id: 'MHK16-1',
        imgUrl: 'Ak8KSur.jpg',
        color: 'targetLinkTwoColor',
    },
    { cluster: 'cluster4', source: 11, target: 45, value: 1, valueid: ['targetca', 'repc'], paperName: 'MHK16', process: 'MHK16_1', id: 'MHK16-4', imgUrl: 'Ak8KSur.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 12, target: 45, value: 1, valueid: ['targetca', 'repc'], paperName: 'MHK16', process: 'MHK16_1', id: 'MHK16-5', imgUrl: 'Ak8KSur.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 45, target: 53, value: 1, valueid: ['targetca', 'repc'], paperName: 'MHK16', process: 'MHK16_1', id: 'MHK16-9', imgUrl: 'Ak8KSur.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 53, target: 76, value: 1, valueid: ['targetca', 'repc'], paperName: 'MHK16', process: 'MHK16_1', id: 'MHK16-11', imgUrl: 'Ak8KSur.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 53, target: 77, value: 1, valueid: ['targetca', 'repc'], paperName: 'MHK16', process: 'MHK16_1', id: 'MHK16-12', imgUrl: 'Ak8KSur.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 53, target: 78, value: 1, valueid: ['targetca', 'repc'], paperName: 'MHK16', process: 'MHK16_1', id: 'MHK16-13', imgUrl: 'Ak8KSur.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 53, target: 80, value: 1, valueid: ['targetca', 'repc'], paperName: 'MHK16', process: 'MHK16_1', id: 'MHK16-14', imgUrl: 'Ak8KSur.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 53, target: 84, value: 1, valueid: ['targetca', 'repc'], paperName: 'MHK16', process: 'MHK16_1', id: 'MHK16-15', imgUrl: 'Ak8KSur.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 125, target: 0, value: 1, valueid: 'targetab', paperName: 'PC15PV', process: 'PC15PV_1', id: 'PC15PV-0', imgUrl: 'AEd0LAv.jpg', color: 'targetLinkColor' },
    { cluster: 'cluster4', source: 0, target: 45, value: 1, valueid: 'targetab', paperName: 'PC15PV', process: 'PC15PV_1', id: 'PC15PV-6', imgUrl: 'AEd0LAv.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 3, target: 45, value: 1, valueid: ['targetab', 'repd'], paperName: 'PC15PV', process: 'PC15PV_2', id: 'PC15PV-7', imgUrl: 'AEd0LAv.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 45, target: 52, value: 1, valueid: 'targetab', paperName: 'PC15PV', process: 'PC15PV_1', id: 'PC15PV-12', imgUrl: 'AEd0LAv.jpg', color: 'intFourLinkColor' },
    {
        cluster: 'cluster4',
        source: 45,
        target: 55,
        value: 1,
        valueid: ['targetab', 'repd'],
        paperName: 'PC15PV',
        process: 'PC15PV_2',
        id: 'PC15PV-14',
        imgUrl: 'AEd0LAv.jpg',
        color: 'intFourLinkColor',
    },
    { cluster: 'cluster4', source: 52, target: 77, value: 1, valueid: 'targetab', paperName: 'PC15PV', process: 'PC15PV_1', id: 'PC15PV-17', imgUrl: 'AEd0LAv.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 52, target: 79, value: 1, valueid: 'targetab', paperName: 'PC15PV', process: 'PC15PV_1', id: 'PC15PV-19', imgUrl: 'AEd0LAv.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 55, target: 78, value: 1, valueid: ['targetab', 'repd'], paperName: 'PC15PV', process: 'PC15PV_2', id: 'PC15PV-21', imgUrl: 'AEd0LAv.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 126, target: 11, value: 1, valueid: 'targetab', paperName: 'REP15', process: 'REP15_3', id: 'REP15-2', imgUrl: 'y8mGv81.jpg', color: 'targetLinkTwoColor' },
    { cluster: 'cluster4', source: 11, target: 45, value: 1, valueid: 'targetab', paperName: 'REP15', process: 'REP15_3', id: 'REP15-5', imgUrl: 'y8mGv81.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 45, target: 50, value: 1, valueid: 'targetab', paperName: 'REP15', process: 'REP15_3', id: 'REP15-8', imgUrl: 'y8mGv81.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 50, target: 76, value: 1, valueid: 'targetab', paperName: 'REP15', process: 'REP15_3', id: 'REP15-9', imgUrl: 'y8mGv81.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 50, target: 79, value: 1, valueid: 'targetab', paperName: 'REP15', process: 'REP15_3', id: 'REP15-12', imgUrl: 'y8mGv81.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 50, target: 80, value: 1, valueid: 'targetab', paperName: 'REP15', process: 'REP15_3', id: 'REP15-15', imgUrl: 'y8mGv81.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 132, target: 11, value: 1, valueid: ['targetcb', 'repc'], paperName: 'XD99', process: ' XD99_1', id: 'XD99-0', imgUrl: 'CaBMwKE.jpg', color: 'targetLinkTwoColor' },
    { cluster: 'cluster4', source: 11, target: 45, value: 1, valueid: ['targetcb', 'repc'], paperName: 'XD99', process: ' XD99_1', id: 'XD99-6', imgUrl: 'CaBMwKE.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 45, target: 53, value: 1, valueid: ['targetcb', 'repc'], paperName: 'XD99', process: ' XD99_1', id: 'XD99-12', imgUrl: 'CaBMwKE.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 53, target: 77, value: 1, valueid: ['targetcb', 'repc'], paperName: 'XD99', process: ' XD99_1', id: 'XD99-20', imgUrl: 'CaBMwKE.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 133, target: 6, value: 1, valueid: 'targetba', paperName: 'XWL17', process: 'XWL17_1', id: 'XWL17-0', imgUrl: 'VqSzaXU.jpg', color: 'targetLinkColor' },
    { cluster: 'cluster4', source: 133, target: 15, value: 1, valueid: 'targetba', paperName: 'XWL17', process: 'XWL17_2', id: 'XWL17-2', imgUrl: 'VqSzaXU.jpg', color: 'targetLinkTwoColor' },
    { cluster: 'cluster4', source: 6, target: 45, value: 1, valueid: 'targetba', paperName: 'XWL17', process: 'XWL17_1', id: 'XWL17-5', imgUrl: 'VqSzaXU.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 15, target: 45, value: 1, valueid: 'targetba', paperName: 'XWL17', process: 'XWL17_2', id: 'XWL17-9', imgUrl: 'VqSzaXU.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 45, target: 61, value: 1, valueid: 'targetba', paperName: 'XWL17', process: 'XWL17_1', id: 'XWL17-11', imgUrl: 'VqSzaXU.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 45, target: 61, value: 1, valueid: 'targetba', paperName: 'XWL17', process: 'XWL17_2', id: 'XWL17-12', imgUrl: 'VqSzaXU.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 61, target: 77, value: 1, valueid: 'targetba', paperName: 'XWL17', process: 'XWL17_1', id: 'XWL17-13', imgUrl: 'VqSzaXU.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 61, target: 77, value: 1, valueid: 'targetba', paperName: 'XWL17', process: 'XWL17_2', id: 'XWL17-14', imgUrl: 'VqSzaXU.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 61, target: 84, value: 1, valueid: 'targetba', paperName: 'XWL17', process: 'XWL17_2', id: 'XWL17-15', imgUrl: 'VqSzaXU.jpg', color: 'repVisTechColor' },
    {
        cluster: 'cluster4',
        source: 134,
        target: 11,
        value: 1,
        valueid: ['targetab', 'repc'],
        paperName: 'XWS16',
        process: 'XWS16_3',
        id: 'XWS16-0',
        imgUrl: 'xn5MqwV.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 134,
        target: 11,
        value: 1,
        valueid: ['targetab', 'repd'],
        paperName: 'XWS16',
        process: 'XWS16_2',
        id: 'XWS16-3',
        imgUrl: 'xn5MqwV.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 134,
        target: 16,
        value: 1,
        valueid: ['targetab', 'repc'],
        paperName: 'XWS16',
        process: 'XWS16_5',
        id: 'XWS16-4',
        imgUrl: 'xn5MqwV.jpg',
        color: 'targetLinkThreeColor',
    },
    {
        cluster: 'cluster4',
        source: 134,
        target: 16,
        value: 1,
        valueid: ['targetab', 'repd'],
        paperName: 'XWS16',
        process: 'XWS16_6',
        id: 'XWS16-5',
        imgUrl: 'xn5MqwV.jpg',
        color: 'targetLinkThreeColor',
    },
    { cluster: 'cluster4', source: 11, target: 45, value: 1, valueid: ['targetab', 'repc'], paperName: 'XWS16', process: 'XWS16_3', id: 'XWS16-9', imgUrl: 'xn5MqwV.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 11, target: 45, value: 1, valueid: ['targetab', 'repd'], paperName: 'XWS16', process: 'XWS16_2', id: 'XWS16-10', imgUrl: 'xn5MqwV.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 16, target: 45, value: 1, valueid: ['targetab', 'repc'], paperName: 'XWS16', process: 'XWS16_5', id: 'XWS16-12', imgUrl: 'xn5MqwV.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 16, target: 45, value: 1, valueid: ['targetab', 'repd'], paperName: 'XWS16', process: 'XWS16_6', id: 'XWS16-13', imgUrl: 'xn5MqwV.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 45, target: 53, value: 1, valueid: ['targetab', 'repc'], paperName: 'XWS16', process: 'XWS16_3', id: 'XWS16-17', imgUrl: 'xn5MqwV.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 45, target: 53, value: 1, valueid: ['targetab', 'repc'], paperName: 'XWS16', process: 'XWS16_5', id: 'XWS16-18', imgUrl: 'xn5MqwV.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 45, target: 55, value: 1, valueid: ['targetab', 'repd'], paperName: 'XWS16', process: 'XWS16_2', id: 'XWS16-20', imgUrl: 'xn5MqwV.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 45, target: 55, value: 1, valueid: ['targetab', 'repd'], paperName: 'XWS16', process: 'XWS16_6', id: 'XWS16-21', imgUrl: 'xn5MqwV.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 53, target: 76, value: 1, valueid: ['targetab', 'repc'], paperName: 'XWS16', process: 'XWS16_5', id: 'XWS16-22', imgUrl: 'xn5MqwV.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 53, target: 77, value: 1, valueid: ['targetab', 'repc'], paperName: 'XWS16', process: 'XWS16_3', id: 'XWS16-23', imgUrl: 'xn5MqwV.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 55, target: 77, value: 1, valueid: ['targetab', 'repd'], paperName: 'XWS16', process: 'XWS16_2', id: 'XWS16-25', imgUrl: 'xn5MqwV.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 53, target: 78, value: 1, valueid: ['targetab', 'repc'], paperName: 'XWS16', process: 'XWS16_3', id: 'XWS16-26', imgUrl: 'xn5MqwV.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 53, target: 79, value: 1, valueid: ['targetab', 'repc'], paperName: 'XWS16', process: 'XWS16_3', id: 'XWS16-27', imgUrl: 'xn5MqwV.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 55, target: 78, value: 1, valueid: ['targetab', 'repd'], paperName: 'XWS16', process: 'XWS16_2', id: 'XWS16-29', imgUrl: 'xn5MqwV.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 55, target: 85, value: 1, valueid: ['targetab', 'repd'], paperName: 'XWS16', process: 'XWS16_2', id: 'XWS16-32', imgUrl: 'xn5MqwV.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 55, target: 85, value: 1, valueid: ['targetab', 'repd'], paperName: 'XWS16', process: 'XWS16_6', id: 'XWS16-33', imgUrl: 'xn5MqwV.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 55, target: 88, value: 1, valueid: ['targetab', 'repd'], paperName: 'XWS16', process: 'XWS16_2', id: 'XWS16-34', imgUrl: 'xn5MqwV.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 55, target: 92, value: 1, valueid: ['targetab', 'repd'], paperName: 'XWS16', process: 'XWS16_6', id: 'XWS16-36', imgUrl: 'xn5MqwV.jpg', color: 'repVisTechColor' },
    {
        cluster: 'cluster4',
        source: 135,
        target: 11,
        value: 1,
        valueid: ['repea', 'targetbb'],
        paperName: 'YFS10',
        process: 'YFS10_1',
        id: 'YFS10-0',
        imgUrl: 'A14dGOk.png',
        color: 'targetLinkTwoColor',
    },
    { cluster: 'cluster4', source: 11, target: 45, value: 1, valueid: ['repea', 'targetbb'], paperName: 'YFS10', process: 'YFS10_1', id: 'YFS10-2', imgUrl: 'A14dGOk.png', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 45, target: 59, value: 1, valueid: ['repea', 'targetbb'], paperName: 'YFS10', process: 'YFS10_1', id: 'YFS10-4', imgUrl: 'A14dGOk.png', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 59, target: 76, value: 1, valueid: ['repea', 'targetbb'], paperName: 'YFS10', process: 'YFS10_1', id: 'YFS10-5', imgUrl: 'A14dGOk.png', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 59, target: 78, value: 1, valueid: ['repea', 'targetbb'], paperName: 'YFS10', process: 'YFS10_1', id: 'YFS10-6', imgUrl: 'A14dGOk.png', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 59, target: 92, value: 1, valueid: ['repea', 'targetbb'], paperName: 'YFS10', process: 'YFS10_1', id: 'YFS10-7', imgUrl: 'A14dGOk.png', color: 'repVisTechColor' },
    {
        cluster: 'cluster4',
        source: 135,
        target: 12,
        value: 1,
        valueid: ['repea', 'targetbb'],
        paperName: 'YFS10',
        process: 'YFS10_2',
        id: 'YFS10-8',
        imgUrl: 'A14dGOk.png',
        color: 'targetLinkTwoColor',
    },
    { cluster: 'cluster4', source: 12, target: 45, value: 1, valueid: ['repea', 'targetbb'], paperName: 'YFS10', process: 'YFS10_2', id: 'YFS10-10', imgUrl: 'A14dGOk.png', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 45, target: 59, value: 1, valueid: ['repea', 'targetbb'], paperName: 'YFS10', process: 'YFS10_2', id: 'YFS10-12', imgUrl: 'A14dGOk.png', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 59, target: 76, value: 1, valueid: ['repea', 'targetbb'], paperName: 'YFS10', process: 'YFS10_2', id: 'YFS10-13', imgUrl: 'A14dGOk.png', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 59, target: 78, value: 1, valueid: ['repea', 'targetbb'], paperName: 'YFS10', process: 'YFS10_2', id: 'YFS10-14', imgUrl: 'A14dGOk.png', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 59, target: 92, value: 1, valueid: ['repea', 'targetbb'], paperName: 'YFS10', process: 'YFS10_2', id: 'YFS10-15', imgUrl: 'A14dGOk.png', color: 'repVisTechColor' },
    {
        cluster: 'cluster4',
        source: 135,
        target: 16,
        value: 1,
        valueid: ['repf', 'targetbb'],
        paperName: 'YFS10',
        process: 'YFS10_3',
        id: 'YFS10-16',
        imgUrl: 'A14dGOk.png',
        color: 'targetLinkThreeColor',
    },
    { cluster: 'cluster4', source: 16, target: 45, value: 1, valueid: ['repf', 'targetbb'], paperName: 'YFS10', process: 'YFS10_3', id: 'YFS10-17', imgUrl: 'A14dGOk.png', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 45, target: 60, value: 1, valueid: ['repf', 'targetbb'], paperName: 'YFS10', process: 'YFS10_3', id: 'YFS10-18', imgUrl: 'A14dGOk.png', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 60, target: 77, value: 1, valueid: ['repf', 'targetbb'], paperName: 'YFS10', process: 'YFS10_3', id: 'YFS10-19', imgUrl: 'A14dGOk.png', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 60, target: 86, value: 1, valueid: ['repf', 'targetbb'], paperName: 'YFS10', process: 'YFS10_3', id: 'YFS10-20', imgUrl: 'A14dGOk.png', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 60, target: 94, value: 1, valueid: ['repf', 'targetbb'], paperName: 'YFS10', process: 'YFS10_3', id: 'YFS10-21', imgUrl: 'A14dGOk.png', color: 'repVisTechColor' },
    {
        cluster: 'cluster4',
        source: 135,
        target: 16,
        value: 1,
        valueid: ['repea', 'targetbb'],
        paperName: 'YFS10',
        process: 'YFS10_4',
        id: 'YFS10-22',
        imgUrl: 'A14dGOk.png',
        color: 'targetLinkThreeColor',
    },
    { cluster: 'cluster4', source: 16, target: 45, value: 1, valueid: ['repea', 'targetbb'], paperName: 'YFS10', process: 'YFS10_4', id: 'YFS10-23', imgUrl: 'A14dGOk.png', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 45, target: 59, value: 1, valueid: ['repea', 'targetbb'], paperName: 'YFS10', process: 'YFS10_4', id: 'YFS10-24', imgUrl: 'A14dGOk.png', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 59, target: 77, value: 1, valueid: ['repea', 'targetbb'], paperName: 'YFS10', process: 'YFS10_4', id: 'YFS10-25', imgUrl: 'A14dGOk.png', color: 'repVisVarColor' },
    {
        cluster: 'cluster4',
        source: 139,
        target: 11,
        value: 1,
        valueid: ['repd ', 'targetbb'],
        paperName: 'RSRY12',
        process: 'RSRY12_1',
        id: 'RSRY12-0',
        imgUrl: 'ivVW2HN.png',
        color: 'targetLinkTwoColor',
    },
    { cluster: 'cluster4', source: 139, target: 16, value: 1, valueid: 'repd', paperName: 'RSRY12', process: 'RSRY12_3', id: 'RSRY12-2', imgUrl: 'ivVW2HN.png', color: 'targetLinkThreeColor' },
    {
        cluster: 'cluster4',
        source: 11,
        target: 45,
        value: 1,
        valueid: ['repd ', 'targetbb'],
        paperName: 'RSRY12',
        process: 'RSRY12_1',
        id: 'RSRY12-4',
        imgUrl: 'ivVW2HN.png',
        color: 'intFourLinkColor',
    },
    { cluster: 'cluster4', source: 16, target: 45, value: 1, valueid: 'repd ', paperName: 'RSRY12', process: 'RSRY12_3', id: 'RSRY12-6', imgUrl: 'ivVW2HN.png', color: 'intFourLinkColor' },
    {
        cluster: 'cluster4',
        source: 45,
        target: 55,
        value: 1,
        valueid: ['repd ', 'targetbb'],
        paperName: 'RSRY12',
        process: 'RSRY12_1',
        id: 'RSRY12-8',
        imgUrl: 'ivVW2HN.png',
        color: 'intFourLinkColor',
    },
    { cluster: 'cluster4', source: 45, target: 55, value: 1, valueid: 'repd', paperName: 'RSRY12', process: 'RSRY12_3', id: 'RSRY12-9', imgUrl: 'ivVW2HN.png', color: 'intFourLinkColor' },
    {
        cluster: 'cluster4',
        source: 55,
        target: 77,
        value: 1,
        valueid: ['repd ', 'targetbb'],
        paperName: 'RSRY12',
        process: 'RSRY12_1',
        id: 'RSRY12-11',
        imgUrl: 'ivVW2HN.png',
        color: 'repVisVarColor',
    },
    {
        cluster: 'cluster4',
        source: 55,
        target: 78,
        value: 1,
        valueid: ['repd ', 'targetbb'],
        paperName: 'RSRY12',
        process: 'RSRY12_1',
        id: 'RSRY12-12',
        imgUrl: 'ivVW2HN.png',
        color: 'repVisVarColor',
    },
    { cluster: 'cluster4', source: 55, target: 78, value: 1, valueid: 'repd ', paperName: 'RSRY12', process: 'RSRY12_3', id: 'RSRY12-13', imgUrl: 'ivVW2HN.png', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 55, target: 85, value: 1, valueid: 'repd ', paperName: 'RSRY12', process: 'RSRY12_3', id: 'RSRY12-14', imgUrl: 'ivVW2HN.png', color: 'repVisTechColor' },
    {
        cluster: 'cluster4',
        source: 55,
        target: 86,
        value: 1,
        valueid: ['repd ', 'targetbb'],
        paperName: 'RSRY12',
        process: 'RSRY12_1',
        id: 'RSRY12-15',
        imgUrl: 'ivVW2HN.png',
        color: 'repVisTechColor',
    },
    {
        cluster: 'cluster4',
        source: 140,
        target: 15,
        value: 1,
        valueid: ['repf', ' targetca'],
        paperName: 'FAKM15',
        process: 'FAKM15_1',
        id: 'FAKM15-0',
        imgUrl: 'u2sWSNe.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 15,
        target: 45,
        value: 1,
        valueid: ['repf', ' targetca'],
        paperName: 'FAKM15',
        process: 'FAKM15_1',
        id: 'FAKM15-2',
        imgUrl: 'u2sWSNe.jpg',
        color: 'intFourLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 45,
        target: 60,
        value: 1,
        valueid: ['repf', ' targetca'],
        paperName: 'FAKM15',
        process: 'FAKM15_1',
        id: 'FAKM15-4',
        imgUrl: 'u2sWSNe.jpg',
        color: 'intFourLinkColor',
    },
    { cluster: 'cluster4', source: 60, target: 76, value: 1, valueid: ['repf', ' targetca'], paperName: 'FAKM15', process: 'FAKM15_1', id: 'FAKM15-5', imgUrl: 'u2sWSNe.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 60, target: 77, value: 1, valueid: ['repf', ' targetca'], paperName: 'FAKM15', process: 'FAKM15_1', id: 'FAKM15-6', imgUrl: 'u2sWSNe.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 142, target: 11, value: 1, valueid: 'repd', paperName: 'CSL16', process: 'CSL16_3', id: 'CSL16-2', imgUrl: 'mt871Nx.png', color: 'targetLinkTwoColor' },
    { cluster: 'cluster4', source: 142, target: 13, value: 1, valueid: 'repd', paperName: 'CSL16', process: 'CSL16_3', id: 'CSL16-3', imgUrl: 'mt871Nx.png', color: 'targetLinkTwoColor' },
    { cluster: 'cluster4', source: 11, target: 45, value: 1, valueid: 'repd', paperName: 'CSL16', process: 'CSL16_3', id: 'CSL16-17', imgUrl: 'mt871Nx.png', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 13, target: 45, value: 1, valueid: 'repd', paperName: 'CSL16', process: 'CSL16_3', id: 'CSL16-18', imgUrl: 'mt871Nx.png', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 45, target: 55, value: 1, valueid: 'repd', paperName: 'CSL16', process: 'CSL16_3', id: 'CSL16-19', imgUrl: 'mt871Nx.png', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 55, target: 77, value: 1, valueid: 'repd', paperName: 'CSL16', process: 'CSL16_3', id: 'CSL16-20', imgUrl: 'mt871Nx.png', color: 'repVisVarColor' },
    {
        cluster: 'cluster4',
        source: 144,
        target: 11,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'YCC20',
        process: 'YCC20_4',
        id: 'YCC20-3',
        imgUrl: 'RYq4EGR.jpg',
        color: 'targetLinkTwoColor',
    },
    { cluster: 'cluster4', source: 11, target: 45, value: 1, valueid: ['targetca', 'repc'], paperName: 'YCC20', process: 'YCC20_4', id: 'YCC20-12', imgUrl: 'RYq4EGR.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 45, target: 53, value: 1, valueid: ['targetca', 'repc'], paperName: 'YCC20', process: 'YCC20_4', id: 'YCC20-21', imgUrl: 'RYq4EGR.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 53, target: 77, value: 1, valueid: ['targetca', 'repc'], paperName: 'YCC20', process: 'YCC20_4', id: 'YCC20-23', imgUrl: 'RYq4EGR.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 53, target: 76, value: 1, valueid: ['targetca', 'repc'], paperName: 'YCC20', process: 'YCC20_4', id: 'YCC20-25', imgUrl: 'RYq4EGR.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 145, target: 5, value: 1, valueid: ['targetbb', 'repb'], paperName: 'MDDD16', process: 'MDDD16_1', id: 'MDDD16-0', imgUrl: '4teJby0.jpg', color: 'targetLinkColor' },
    { cluster: 'cluster4', source: 145, target: 5, value: 1, valueid: ['targetbb', 'repb'], paperName: 'MDDD16', process: 'MDDD16_2', id: 'MDDD16-1', imgUrl: '4teJby0.jpg', color: 'targetLinkColor' },
    {
        cluster: 'cluster4',
        source: 145,
        target: 12,
        value: 1,
        valueid: ['targetbb', 'repb'],
        paperName: 'MDDD16',
        process: 'MDDD16_1',
        id: 'MDDD16-2',
        imgUrl: '4teJby0.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 145,
        target: 12,
        value: 1,
        valueid: ['targetbb', 'repb'],
        paperName: 'MDDD16',
        process: 'MDDD16_2',
        id: 'MDDD16-3',
        imgUrl: '4teJby0.jpg',
        color: 'targetLinkTwoColor',
    },
    { cluster: 'cluster4', source: 5, target: 45, value: 1, valueid: ['targetbb', 'repb'], paperName: 'MDDD16', process: 'MDDD16_1', id: 'MDDD16-7', imgUrl: '4teJby0.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 5, target: 45, value: 1, valueid: ['targetbb', 'repb'], paperName: 'MDDD16', process: 'MDDD16_2', id: 'MDDD16-8', imgUrl: '4teJby0.jpg', color: 'intFourLinkColor' },
    {
        cluster: 'cluster4',
        source: 12,
        target: 45,
        value: 1,
        valueid: ['targetbb', 'repb'],
        paperName: 'MDDD16',
        process: 'MDDD16_1',
        id: 'MDDD16-11',
        imgUrl: '4teJby0.jpg',
        color: 'intFourLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 12,
        target: 45,
        value: 1,
        valueid: ['targetbb', 'repb'],
        paperName: 'MDDD16',
        process: 'MDDD16_2',
        id: 'MDDD16-12',
        imgUrl: '4teJby0.jpg',
        color: 'intFourLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 45,
        target: 54,
        value: 1,
        valueid: ['targetbb', 'repb'],
        paperName: 'MDDD16',
        process: 'MDDD16_1',
        id: 'MDDD16-16',
        imgUrl: '4teJby0.jpg',
        color: 'intFourLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 45,
        target: 70,
        value: 1,
        valueid: ['targetbb', 'repb'],
        paperName: 'MDDD16',
        process: 'MDDD16_2',
        id: 'MDDD16-17',
        imgUrl: '4teJby0.jpg',
        color: 'intFourLinkColor',
    },
    { cluster: 'cluster4', source: 54, target: 77, value: 1, valueid: ['targetbb', 'repb'], paperName: 'MDDD16', process: 'MDDD16_1', id: 'MDDD16-18', imgUrl: '4teJby0.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 54, target: 78, value: 1, valueid: ['targetbb', 'repb'], paperName: 'MDDD16', process: 'MDDD16_1', id: 'MDDD16-20', imgUrl: '4teJby0.jpg', color: 'repVisVarColor' },
    {
        cluster: 'cluster4',
        source: 70,
        target: 98,
        value: 1,
        valueid: ['targetbb', 'repb'],
        paperName: 'MDDD16',
        process: 'MDDD16_2',
        id: 'MDDD16-22',
        imgUrl: '4teJby0.jpg',
        color: 'repVisTechColor',
    },
    {
        cluster: 'cluster4',
        source: 146,
        target: 11,
        value: 1,
        valueid: ['targetab', 'repb'],
        paperName: 'GYS14',
        process: 'GYS14_4',
        id: 'GYS14-4',
        imgUrl: 'r9tEkOr.jpg',
        color: 'targetLinkTwoColor',
    },
    { cluster: 'cluster4', source: 146, target: 18, value: 1, valueid: 'repb', paperName: 'GYS14', process: 'GYS14_5', id: 'GYS14-7', imgUrl: 'r9tEkOr.jpg', color: 'targetLinkThreeColor' },
    { cluster: 'cluster4', source: 11, target: 45, value: 1, valueid: ['targetab', 'repb'], paperName: 'GYS14', process: 'GYS14_4', id: 'GYS14-11', imgUrl: 'r9tEkOr.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 18, target: 45, value: 1, valueid: 'repb', paperName: 'GYS14', process: 'GYS14_5', id: 'GYS14-14', imgUrl: 'r9tEkOr.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 45, target: 54, value: 1, valueid: ['targetab', 'repb'], paperName: 'GYS14', process: 'GYS14_4', id: 'GYS14-18', imgUrl: 'r9tEkOr.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 45, target: 54, value: 1, valueid: 'repb', paperName: 'GYS14', process: 'GYS14_5', id: 'GYS14-19', imgUrl: 'r9tEkOr.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 54, target: 76, value: 1, valueid: ['targetab', 'repb'], paperName: 'GYS14', process: 'GYS14_4', id: 'GYS14-26', imgUrl: 'r9tEkOr.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 54, target: 76, value: 1, valueid: 'repb', paperName: 'GYS14', process: 'GYS14_5', id: 'GYS14-28', imgUrl: 'r9tEkOr.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 54, target: 77, value: 1, valueid: ['targetab', 'repb'], paperName: 'GYS14', process: 'GYS14_4', id: 'GYS14-30', imgUrl: 'r9tEkOr.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 54, target: 77, value: 1, valueid: 'repb', paperName: 'GYS14', process: 'GYS14_5', id: 'GYS14-32', imgUrl: 'r9tEkOr.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 54, target: 78, value: 1, valueid: ['targetab', 'repb'], paperName: 'GYS14', process: 'GYS14_4', id: 'GYS14-33', imgUrl: 'r9tEkOr.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 54, target: 78, value: 1, valueid: 'repb', paperName: 'GYS14', process: 'GYS14_5', id: 'GYS14-34', imgUrl: 'r9tEkOr.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 54, target: 80, value: 1, valueid: ['targetab', 'repb'], paperName: 'GYS14', process: 'GYS14_4', id: 'GYS14-36', imgUrl: 'r9tEkOr.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 54, target: 80, value: 1, valueid: 'repb', paperName: 'GYS14', process: 'GYS14_5', id: 'GYS14-38', imgUrl: 'r9tEkOr.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 54, target: 92, value: 1, valueid: ['targetab', 'repb'], paperName: 'GYS14', process: 'GYS14_4', id: 'GYS14-40', imgUrl: 'r9tEkOr.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 54, target: 92, value: 1, valueid: 'repb', paperName: 'GYS14', process: 'GYS14_5', id: 'GYS14-43', imgUrl: 'r9tEkOr.jpg', color: 'repVisTechColor' },
    {
        cluster: 'cluster4',
        source: 152,
        target: 11,
        value: 1,
        valueid: ['repg', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_5',
        id: 'WHWS12-12',
        imgUrl: 'sp1TtaX.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 11,
        target: 45,
        value: 1,
        valueid: ['repg', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_5',
        id: 'WHWS12-60',
        imgUrl: 'sp1TtaX.jpg',
        color: 'intFourLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 45,
        target: 68,
        value: 1,
        valueid: ['repg', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_5',
        id: 'WHWS12-64',
        imgUrl: 'sp1TtaX.jpg',
        color: 'intFourLinkColor',
    },
    { cluster: 'cluster4', source: 68, target: 76, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_5', id: 'WHWS12-65', imgUrl: 'sp1TtaX.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 68, target: 77, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_5', id: 'WHWS12-66', imgUrl: 'sp1TtaX.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 68, target: 78, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_5', id: 'WHWS12-67', imgUrl: 'sp1TtaX.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 153, target: 11, value: 1, valueid: 'repg', paperName: 'FZC18', process: 'FZC18_2', id: 'FZC18-0', imgUrl: 'zz8t6eU.jpg', color: 'targetLinkTwoColor' },
    { cluster: 'cluster4', source: 153, target: 11, value: 1, valueid: 'repf', paperName: 'FZC18', process: 'FZC18_1', id: 'FZC18-2', imgUrl: 'zz8t6eU.jpg', color: 'targetLinkTwoColor' },
    { cluster: 'cluster4', source: 153, target: 13, value: 1, valueid: 'repg', paperName: 'FZC18', process: 'FZC18_2', id: 'FZC18-3', imgUrl: 'zz8t6eU.jpg', color: 'targetLinkTwoColor' },
    { cluster: 'cluster4', source: 153, target: 13, value: 1, valueid: 'repf', paperName: 'FZC18', process: 'FZC18_1', id: 'FZC18-5', imgUrl: 'zz8t6eU.jpg', color: 'targetLinkTwoColor' },
    { cluster: 'cluster4', source: 153, target: 20, value: 1, valueid: 'repf', paperName: 'FZC18', process: 'FZC18_4', id: 'FZC18-7', imgUrl: 'zz8t6eU.jpg', color: 'targetLinkThreeColor' },
    { cluster: 'cluster4', source: 11, target: 45, value: 1, valueid: 'repf', paperName: 'FZC18', process: 'FZC18_1', id: 'FZC18-16', imgUrl: 'zz8t6eU.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 11, target: 45, value: 1, valueid: 'repg', paperName: 'FZC18', process: 'FZC18_2', id: 'FZC18-17', imgUrl: 'zz8t6eU.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 13, target: 45, value: 1, valueid: 'repf', paperName: 'FZC18', process: 'FZC18_1', id: 'FZC18-18', imgUrl: 'zz8t6eU.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 13, target: 45, value: 1, valueid: 'repg', paperName: 'FZC18', process: 'FZC18_2', id: 'FZC18-19', imgUrl: 'zz8t6eU.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 60, target: 92, value: 1, valueid: 'repf', paperName: 'FZC18', process: 'FZC18_1', id: 'FZC18-20', imgUrl: 'zz8t6eU.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 45, target: 68, value: 1, valueid: 'repg', paperName: 'FZC18', process: 'FZC18_2', id: 'FZC18-21', imgUrl: 'zz8t6eU.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 68, target: 81, value: 1, valueid: 'repg', paperName: 'FZC18', process: 'FZC18_2', id: 'FZC18-22', imgUrl: 'zz8t6eU.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 20, target: 45, value: 1, valueid: 'repf', paperName: 'FZC18', process: 'FZC18_4', id: 'FZC18-23', imgUrl: 'zz8t6eU.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 45, target: 60, value: 1, valueid: 'repf', paperName: 'FZC18', process: 'FZC18_1', id: 'FZC18-24', imgUrl: 'zz8t6eU.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 45, target: 60, value: 1, valueid: 'repf', paperName: 'FZC18', process: 'FZC18_4', id: 'FZC18-25', imgUrl: 'zz8t6eU.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 159, target: 5, value: 1, valueid: ['targetbb', 'repea'], paperName: 'ASG21', process: 'ASG21_2', id: 'ASG21-1', imgUrl: 'JY2gfvN.jpg', color: 'targetLinkColor' },
    {
        cluster: 'cluster4',
        source: 159,
        target: 15,
        value: 1,
        valueid: ['targetbb', 'repea'],
        paperName: 'ASG21',
        process: 'ASG21_2',
        id: 'ASG21-2',
        imgUrl: 'JY2gfvN.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 159,
        target: 13,
        value: 1,
        valueid: ['targetaa', 'repea'],
        paperName: 'ASG21',
        process: 'ASG21_3',
        id: 'ASG21-3',
        imgUrl: 'JY2gfvN.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 159,
        target: 18,
        value: 1,
        valueid: ['targetaa', 'repea'],
        paperName: 'ASG21',
        process: 'ASG21_3',
        id: 'ASG21-4',
        imgUrl: 'JY2gfvN.jpg',
        color: 'targetLinkThreeColor',
    },
    { cluster: 'cluster4', source: 5, target: 45, value: 1, valueid: ['targetbb', 'repea'], paperName: 'ASG21', process: 'ASG21_2', id: 'ASG21-9', imgUrl: 'JY2gfvN.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 15, target: 45, value: 1, valueid: ['targetbb', 'repea'], paperName: 'ASG21', process: 'ASG21_2', id: 'ASG21-10', imgUrl: 'JY2gfvN.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 45, target: 59, value: 1, valueid: ['targetbb', 'repea'], paperName: 'ASG21', process: 'ASG21_2', id: 'ASG21-11', imgUrl: 'JY2gfvN.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 59, target: 77, value: 1, valueid: ['targetbb', 'repea'], paperName: 'ASG21', process: 'ASG21_2', id: 'ASG21-12', imgUrl: 'JY2gfvN.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 59, target: 78, value: 1, valueid: ['targetbb', 'repea'], paperName: 'ASG21', process: 'ASG21_2', id: 'ASG21-13', imgUrl: 'JY2gfvN.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 13, target: 45, value: 1, valueid: ['targetaa', 'repea'], paperName: 'ASG21', process: 'ASG21_3', id: 'ASG21-14', imgUrl: 'JY2gfvN.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 18, target: 45, value: 1, valueid: ['targetaa', 'repea'], paperName: 'ASG21', process: 'ASG21_3', id: 'ASG21-15', imgUrl: 'JY2gfvN.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 45, target: 59, value: 1, valueid: ['targetaa', 'repea'], paperName: 'ASG21', process: 'ASG21_3', id: 'ASG21-18', imgUrl: 'JY2gfvN.jpg', color: 'intFourLinkColor' },
    { cluster: 'cluster4', source: 59, target: 77, value: 1, valueid: ['targetaa', 'repea'], paperName: 'ASG21', process: 'ASG21_3', id: 'ASG21-20', imgUrl: 'JY2gfvN.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 59, target: 78, value: 1, valueid: ['targetaa', 'repea'], paperName: 'ASG21', process: 'ASG21_3', id: 'ASG21-21', imgUrl: 'JY2gfvN.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 59, target: 90, value: 1, valueid: ['targetaa', 'repea'], paperName: 'ASG21', process: 'ASG21_3', id: 'ASG21-22', imgUrl: 'JY2gfvN.jpg', color: 'repVisTechColor' },

    {
        cluster: 'cluster4',
        source: 102,
        target: 11,
        value: 1,
        valueid: ['targetab', 'targetca', 'repc'],
        paperName: 'CSL12',
        process: 'CSL12_2',
        id: 'CSL12-1',
        imgUrl: 'a3kehFc.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 102,
        target: 12,
        value: 1,
        valueid: ['targetab', 'targetca', 'repc'],
        paperName: 'CSL12',
        process: 'CSL12_2',
        id: 'CSL12-3',
        imgUrl: 'a3kehFc.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 102,
        target: 22,
        value: 1,
        valueid: ['targetcb', 'repc'],
        paperName: 'CSL12',
        process: 'CSL12_7',
        id: 'CSL12-12',
        imgUrl: 'a3kehFc.jpg',
        color: 'targetLinkFourColor',
    },
    {
        cluster: 'cluster4',
        source: 11,
        target: 49,
        value: 1,
        valueid: ['targetab', 'targetca', 'repc'],
        paperName: 'CSL12',
        process: 'CSL12_2',
        id: 'CSL12-15',
        imgUrl: 'a3kehFc.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 12,
        target: 49,
        value: 1,
        valueid: ['targetab', 'targetca', 'repc'],
        paperName: 'CSL12',
        process: 'CSL12_2',
        id: 'CSL12-16',
        imgUrl: 'a3kehFc.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 22,
        target: 49,
        value: 1,
        valueid: ['targetcb', 'repc'],
        paperName: 'CSL12',
        process: 'CSL12_7',
        id: 'CSL12-25',
        imgUrl: 'a3kehFc.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 49,
        target: 53,
        value: 1,
        valueid: ['targetab', 'targetca', 'repc'],
        paperName: 'CSL12',
        process: 'CSL12_2',
        id: 'CSL12-30',
        imgUrl: 'a3kehFc.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 49,
        target: 53,
        value: 1,
        valueid: ['targetcb', 'repc'],
        paperName: 'CSL12',
        process: 'CSL12_7',
        id: 'CSL12-31',
        imgUrl: 'a3kehFc.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 53,
        target: 77,
        value: 1,
        valueid: ['targetab', 'targetca', 'repc'],
        paperName: 'CSL12',
        process: 'CSL12_2',
        id: 'CSL12-34',
        imgUrl: 'a3kehFc.jpg',
        color: 'repVisVarColor',
    },
    {
        cluster: 'cluster4',
        source: 53,
        target: 79,
        value: 1,
        valueid: ['targetab', 'targetca', 'repc'],
        paperName: 'CSL12',
        process: 'CSL12_2',
        id: 'CSL12-35',
        imgUrl: 'a3kehFc.jpg',
        color: 'repVisVarColor',
    },
    { cluster: 'cluster4', source: 53, target: 80, value: 1, valueid: ['targetcb', 'repc'], paperName: 'CSL12', process: 'CSL12_7', id: 'CSL12-38', imgUrl: 'a3kehFc.jpg', color: 'repVisVarColor' },
    {
        cluster: 'cluster4',
        source: 53,
        target: 80,
        value: 1,
        valueid: ['targetab', 'targetca', 'repc'],
        paperName: 'CSL12',
        process: 'CSL12_2',
        id: 'CSL12-39',
        imgUrl: 'a3kehFc.jpg',
        color: 'repVisVarColor',
    },
    { cluster: 'cluster4', source: 105, target: 5, value: 1, valueid: ['targetca', 'repa'], paperName: 'EYG15', process: 'EYG15_1', id: 'EYG15-0', imgUrl: '9p9Vu7Y.jpg', color: 'targetLinkColor' },
    {
        cluster: 'cluster4',
        source: 105,
        target: 11,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_3',
        id: 'EYG15-2',
        imgUrl: '9p9Vu7Y.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 5,
        target: 49,
        value: 1,
        valueid: ['targetca', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_1',
        id: 'EYG15-7',
        imgUrl: '9p9Vu7Y.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 49,
        target: 63,
        value: 1,
        valueid: ['targetca', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_1',
        id: 'EYG15-9',
        imgUrl: '9p9Vu7Y.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 49,
        target: 63,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_3',
        id: 'EYG15-10',
        imgUrl: '9p9Vu7Y.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 63,
        target: 77,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_3',
        id: 'EYG15-12',
        imgUrl: '9p9Vu7Y.jpg',
        color: 'repVisVarColor',
    },
    { cluster: 'cluster4', source: 63, target: 77, value: 1, valueid: ['targetca', 'repa'], paperName: 'EYG15', process: 'EYG15_1', id: 'EYG15-14', imgUrl: '9p9Vu7Y.jpg', color: 'repVisVarColor' },
    {
        cluster: 'cluster4',
        source: 63,
        target: 78,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_3',
        id: 'EYG15-15',
        imgUrl: '9p9Vu7Y.jpg',
        color: 'repVisVarColor',
    },
    {
        cluster: 'cluster4',
        source: 11,
        target: 49,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_3',
        id: 'EYG15-18',
        imgUrl: '9p9Vu7Y.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { cluster: 'cluster4', source: 63, target: 92, value: 1, valueid: ['targetca', 'repa'], paperName: 'EYG15', process: 'EYG15_1', id: 'EYG15-21', imgUrl: '9p9Vu7Y.jpg', color: 'repVisTechColor' },
    {
        cluster: 'cluster4',
        source: 63,
        target: 92,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_3',
        id: 'EYG15-23',
        imgUrl: '9p9Vu7Y.jpg',
        color: 'repVisTechColor',
    },
    {
        cluster: 'cluster4',
        source: 63,
        target: 84,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_3',
        id: 'EYG15-26',
        imgUrl: '9p9Vu7Y.jpg',
        color: 'repVisTechColor',
    },
    {
        cluster: 'cluster4',
        source: 110,
        target: 11,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-0',
        imgUrl: 'TIajUJa.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 110,
        target: 12,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-1',
        imgUrl: 'TIajUJa.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 11,
        target: 49,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-10',
        imgUrl: 'TIajUJa.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 12,
        target: 49,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-11',
        imgUrl: 'TIajUJa.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 49,
        target: 60,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-16',
        imgUrl: 'TIajUJa.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 60,
        target: 80,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-17',
        imgUrl: 'TIajUJa.jpg',
        color: 'repVisVarColor',
    },
    {
        cluster: 'cluster4',
        source: 60,
        target: 77,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-18',
        imgUrl: 'TIajUJa.jpg',
        color: 'repVisVarColor',
    },
    {
        cluster: 'cluster4',
        source: 60,
        target: 92,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-19',
        imgUrl: 'TIajUJa.jpg',
        color: 'repVisTechColor',
    },
    {
        cluster: 'cluster4',
        source: 111,
        target: 12,
        value: 1,
        valueid: ['targetbb', 'targetcb', 'repb'],
        paperName: 'JTM11',
        process: 'JTM11_3',
        id: 'index-2',
        imgUrl: 'AqAwugG.png',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 111,
        target: 17,
        value: 1,
        valueid: ['targetbb', 'repf'],
        paperName: 'JTM11',
        process: 'JTM11_4',
        id: 'index-3',
        imgUrl: 'AqAwugG.png',
        color: 'targetLinkThreeColor',
    },
    {
        cluster: 'cluster4',
        source: 111,
        target: 18,
        value: 1,
        valueid: ['targetbb', 'repf'],
        paperName: 'JTM11',
        process: 'JTM11_4',
        id: 'index-4',
        imgUrl: 'AqAwugG.png',
        color: 'targetLinkThreeColor',
    },
    {
        cluster: 'cluster4',
        source: 111,
        target: 19,
        value: 1,
        valueid: ['targetbb', 'repf'],
        paperName: 'JTM11',
        process: 'JTM11_4',
        id: 'index-5',
        imgUrl: 'AqAwugG.png',
        color: 'targetLinkThreeColor',
    },
    {
        cluster: 'cluster4',
        source: 111,
        target: 22,
        value: 1,
        valueid: ['targetcb', 'repb'],
        paperName: 'JTM11',
        process: 'JTM11_5',
        id: 'index-6',
        imgUrl: 'AqAwugG.png',
        color: 'targetLinkFourColor',
    },
    {
        cluster: 'cluster4',
        source: 12,
        target: 49,
        value: 1,
        valueid: ['targetcb', 'repb'],
        paperName: 'JTM11',
        process: 'JTM11_3',
        id: 'index-10',
        imgUrl: 'AqAwugG.png',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 17,
        target: 49,
        value: 1,
        valueid: ['targetbb', 'repf'],
        paperName: 'JTM11',
        process: 'JTM11_4',
        id: 'index-11',
        imgUrl: 'AqAwugG.png',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 18,
        target: 49,
        value: 1,
        valueid: ['targetbb', 'repf'],
        paperName: 'JTM11',
        process: 'JTM11_4',
        id: 'index-12',
        imgUrl: 'AqAwugG.png',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 19,
        target: 49,
        value: 1,
        valueid: ['targetbb', 'repf'],
        paperName: 'JTM11',
        process: 'JTM11_4',
        id: 'index-13',
        imgUrl: 'AqAwugG.png',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 22,
        target: 49,
        value: 1,
        valueid: ['targetcb', 'repb'],
        paperName: 'JTM11',
        process: 'JTM11_5',
        id: 'index-14',
        imgUrl: 'AqAwugG.png',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 49,
        target: 54,
        value: 1,
        valueid: ['targetbb', 'targetcb', 'repb'],
        paperName: 'JTM11',
        process: 'JTM11_3',
        id: 'index-17',
        imgUrl: 'AqAwugG.png',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 49,
        target: 54,
        value: 1,
        valueid: ['targetbb', 'targetcb', 'repb'],
        paperName: 'JTM11',
        process: 'JTM11_3',
        id: 'index-18',
        imgUrl: 'AqAwugG.png',
        color: 'intFiveLight2LinkColor',
    },
    { cluster: 'cluster4', source: 54, target: 83, value: 1, valueid: ['targetcb', 'repb'], paperName: 'JTM11', process: 'JTM11_3', id: 'index-20', imgUrl: 'AqAwugG.png', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 54, target: 84, value: 1, valueid: ['targetcb', 'repb'], paperName: 'JTM11', process: 'JTM11_3', id: 'index-23', imgUrl: 'AqAwugG.png', color: 'repVisTechColor' },
    {
        cluster: 'cluster4',
        source: 49,
        target: 60,
        value: 1,
        valueid: ['targetbb', 'repf'],
        paperName: 'JTM11',
        process: 'JTM11_4',
        id: 'index-24',
        imgUrl: 'AqAwugG.png',
        color: 'intFiveLight2LinkColor',
    },
    { cluster: 'cluster4', source: 60, target: 77, value: 1, valueid: ['targetbb', 'repf'], paperName: 'JTM11', process: 'JTM11_4', id: 'index-25', imgUrl: 'AqAwugG.png', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 60, target: 84, value: 1, valueid: ['targetbb', 'repf'], paperName: 'JTM11', process: 'JTM11_4', id: 'index-26', imgUrl: 'AqAwugG.png', color: 'repVisTechColor' },
    {
        cluster: 'cluster4',
        source: 112,
        target: 11,
        value: 1,
        valueid: ['targetbb', 'repc'],
        paperName: 'JSM16',
        process: 'JSM16_2',
        id: 'JSM16-2',
        imgUrl: 'n4jwcKO.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 112,
        target: 12,
        value: 1,
        valueid: ['targetbb', 'repc'],
        paperName: 'JSM16',
        process: 'JSM16_2',
        id: 'JSM16-3',
        imgUrl: 'n4jwcKO.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 11,
        target: 49,
        value: 1,
        valueid: ['targetbb', 'repc'],
        paperName: 'JSM16',
        process: 'JSM16_2',
        id: 'JSM16-12',
        imgUrl: 'n4jwcKO.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 12,
        target: 49,
        value: 1,
        valueid: ['targetbb', 'repc'],
        paperName: 'JSM16',
        process: 'JSM16_2',
        id: 'JSM16-16',
        imgUrl: 'n4jwcKO.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 49,
        target: 53,
        value: 1,
        valueid: ['targetbb', 'repc'],
        paperName: 'JSM16',
        process: 'JSM16_2',
        id: 'JSM16-24',
        imgUrl: 'n4jwcKO.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { cluster: 'cluster4', source: 53, target: 77, value: 1, valueid: ['targetbb', 'repc'], paperName: 'JSM16', process: 'JSM16_2', id: 'JSM16-25', imgUrl: 'n4jwcKO.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 53, target: 78, value: 1, valueid: ['targetbb', 'repc'], paperName: 'JSM16', process: 'JSM16_2', id: 'JSM16-27', imgUrl: 'n4jwcKO.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 53, target: 80, value: 1, valueid: ['targetbb', 'repc'], paperName: 'JSM16', process: 'JSM16_2', id: 'JSM16-29', imgUrl: 'n4jwcKO.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 114, target: 11, value: 1, valueid: 'repd', paperName: 'KSBK15', process: 'KSBK15_4', id: 'KSBK15-21', imgUrl: 'AY0EaHs.png', color: 'targetLinkTwoColor' },
    { cluster: 'cluster4', source: 114, target: 13, value: 1, valueid: 'repd', paperName: 'KSBK15', process: 'KSBK15_4', id: 'KSBK15-22', imgUrl: 'AY0EaHs.png', color: 'targetLinkTwoColor' },
    { cluster: 'cluster4', source: 114, target: 15, value: 1, valueid: 'repd', paperName: 'KSBK15', process: 'KSBK15_4', id: 'KSBK15-23', imgUrl: 'AY0EaHs.png', color: 'targetLinkTwoColor' },
    { cluster: 'cluster4', source: 114, target: 11, value: 1, valueid: 'repf', paperName: 'KSBK15', process: 'KSBK15_5', id: 'KSBK15-24', imgUrl: 'AY0EaHs.png', color: 'targetLinkTwoColor' },
    { cluster: 'cluster4', source: 114, target: 13, value: 1, valueid: 'repf', paperName: 'KSBK15', process: 'KSBK15_5', id: 'KSBK15-25', imgUrl: 'AY0EaHs.png', color: 'targetLinkTwoColor' },
    { cluster: 'cluster4', source: 114, target: 15, value: 1, valueid: 'repf', paperName: 'KSBK15', process: 'KSBK15_5', id: 'KSBK15-26', imgUrl: 'AY0EaHs.png', color: 'targetLinkTwoColor' },
    { cluster: 'cluster4', source: 11, target: 49, value: 1, valueid: 'repd', paperName: 'KSBK15', process: 'KSBK15_4', id: 'KSBK15-68', imgUrl: 'AY0EaHs.png', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 13, target: 49, value: 1, valueid: 'repd', paperName: 'KSBK15', process: 'KSBK15_4', id: 'KSBK15-69', imgUrl: 'AY0EaHs.png', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 15, target: 49, value: 1, valueid: 'repd', paperName: 'KSBK15', process: 'KSBK15_4', id: 'KSBK15-70', imgUrl: 'AY0EaHs.png', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 11, target: 49, value: 1, valueid: 'repf', paperName: 'KSBK15', process: 'KSBK15_5', id: 'KSBK15-74', imgUrl: 'AY0EaHs.png', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 13, target: 49, value: 1, valueid: 'repf', paperName: 'KSBK15', process: 'KSBK15_5', id: 'KSBK15-75', imgUrl: 'AY0EaHs.png', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 15, target: 49, value: 1, valueid: 'repf', paperName: 'KSBK15', process: 'KSBK15_5', id: 'KSBK15-76', imgUrl: 'AY0EaHs.png', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 49, target: 55, value: 1, valueid: 'repd', paperName: 'KSBK15', process: 'KSBK15_4', id: 'KSBK15-87', imgUrl: 'AY0EaHs.png', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 49, target: 60, value: 1, valueid: 'repf', paperName: 'KSBK15', process: 'KSBK15_5', id: 'KSBK15-88', imgUrl: 'AY0EaHs.png', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 55, target: 84, value: 1, valueid: 'repd', paperName: 'KSBK15', process: 'KSBK15_4', id: 'KSBK15-94', imgUrl: 'AY0EaHs.png', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 55, target: 85, value: 1, valueid: 'repd', paperName: 'KSBK15', process: 'KSBK15_4', id: 'KSBK15-96', imgUrl: 'AY0EaHs.png', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 116, target: 3, value: 1, valueid: 'repa', paperName: 'LJC18', process: 'LJC18_1', id: 'LJC18-0', imgUrl: 'bYdgkcY.jpg', color: 'targetLinkColor' },
    { cluster: 'cluster4', source: 116, target: 3, value: 1, valueid: 'reph', paperName: 'LJC18', process: 'LJC18_4', id: 'LJC18-1', imgUrl: 'bYdgkcY.jpg', color: 'targetLinkColor' },
    { cluster: 'cluster4', source: 116, target: 3, value: 1, valueid: 'repf', paperName: 'LJC18', process: 'LJC18_3', id: 'LJC18-3', imgUrl: 'bYdgkcY.jpg', color: 'targetLinkColor' },
    { cluster: 'cluster4', source: 116, target: 11, value: 1, valueid: 'repa', paperName: 'LJC18', process: 'LJC18_8', id: 'LJC18-6', imgUrl: 'bYdgkcY.jpg', color: 'targetLinkTwoColor' },
    { cluster: 'cluster4', source: 116, target: 11, value: 1, valueid: 'repf', paperName: 'LJC18', process: 'LJC18_7', id: 'LJC18-7', imgUrl: 'bYdgkcY.jpg', color: 'targetLinkTwoColor' },
    { cluster: 'cluster4', source: 116, target: 23, value: 1, valueid: 'repa', paperName: 'LJC18', process: 'LJC18_10', id: 'LJC18-9', imgUrl: 'bYdgkcY.jpg', color: 'targetLinkFourColor' },
    { cluster: 'cluster4', source: 3, target: 49, value: 1, valueid: 'repf', paperName: 'LJC18', process: 'LJC18_3', id: 'LJC18-13', imgUrl: 'bYdgkcY.jpg', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 3, target: 49, value: 1, valueid: 'repa', paperName: 'LJC18', process: 'LJC18_1', id: 'LJC18-14', imgUrl: 'bYdgkcY.jpg', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 3, target: 49, value: 1, valueid: 'reph', paperName: 'LJC18', process: 'LJC18_4', id: 'LJC18-15', imgUrl: 'bYdgkcY.jpg', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 11, target: 49, value: 1, valueid: 'repf', paperName: 'LJC18', process: 'LJC18_7', id: 'LJC18-16', imgUrl: 'bYdgkcY.jpg', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 11, target: 49, value: 1, valueid: 'repa', paperName: 'LJC18', process: 'LJC18_8', id: 'LJC18-17', imgUrl: 'bYdgkcY.jpg', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 23, target: 49, value: 1, valueid: 'repa', paperName: 'LJC18', process: 'LJC18_10', id: 'LJC18-18', imgUrl: 'bYdgkcY.jpg', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 49, target: 60, value: 1, valueid: 'repf', paperName: 'LJC18', process: 'LJC18_3', id: 'LJC18-23', imgUrl: 'bYdgkcY.jpg', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 49, target: 60, value: 1, valueid: 'repf', paperName: 'LJC18', process: 'LJC18_7', id: 'LJC18-24', imgUrl: 'bYdgkcY.jpg', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 49, target: 62, value: 1, valueid: 'reph', paperName: 'LJC18', process: 'LJC18_4', id: 'LJC18-25', imgUrl: 'bYdgkcY.jpg', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 49, target: 63, value: 1, valueid: 'repa', paperName: 'LJC18', process: 'LJC18_1', id: 'LJC18-26', imgUrl: 'bYdgkcY.jpg', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 49, target: 63, value: 1, valueid: 'repa', paperName: 'LJC18', process: 'LJC18_8', id: 'LJC18-27', imgUrl: 'bYdgkcY.jpg', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 49, target: 63, value: 1, valueid: 'repa', paperName: 'LJC18', process: 'LJC18_10', id: 'LJC18-28', imgUrl: 'bYdgkcY.jpg', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 62, target: 88, value: 1, valueid: 'reph', paperName: 'LJC18', process: 'LJC18_4', id: 'LJC18-32', imgUrl: 'bYdgkcY.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 63, target: 88, value: 1, valueid: 'repa', paperName: 'LJC18', process: 'LJC18_1', id: 'LJC18-33', imgUrl: 'bYdgkcY.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 63, target: 88, value: 1, valueid: 'repa', paperName: 'LJC18', process: 'LJC18_10', id: 'LJC18-34', imgUrl: 'bYdgkcY.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 60, target: 99, value: 1, valueid: 'repf', paperName: 'LJC18', process: 'LJC18_3', id: 'LJC18-40', imgUrl: 'bYdgkcY.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 60, target: 99, value: 1, valueid: 'repf', paperName: 'LJC18', process: 'LJC18_7', id: 'LJC18-41', imgUrl: 'bYdgkcY.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 62, target: 99, value: 1, valueid: 'reph', paperName: 'LJC18', process: 'LJC18_4', id: 'LJC18-42', imgUrl: 'bYdgkcY.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 63, target: 99, value: 1, valueid: 'repa', paperName: 'LJC18', process: 'LJC18_1', id: 'LJC18-43', imgUrl: 'bYdgkcY.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 63, target: 99, value: 1, valueid: 'repa', paperName: 'LJC18', process: 'LJC18_8', id: 'LJC18-44', imgUrl: 'bYdgkcY.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 63, target: 99, value: 1, valueid: 'repa', paperName: 'LJC18', process: 'LJC18_10', id: 'LJC18-45', imgUrl: 'bYdgkcY.jpg', color: 'repVisTechColor' },
    {
        cluster: 'cluster4',
        source: 118,
        target: 11,
        value: 1,
        valueid: ['targetab', 'repeb'],
        paperName: 'LWW13',
        process: 'LWW13_3',
        id: 'LWW13-2',
        imgUrl: 'iaVFFGl.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 118,
        target: 16,
        value: 1,
        valueid: ['targetab', 'repeb'],
        paperName: 'LWW13',
        process: 'LWW13_4',
        id: 'LWW13-4',
        imgUrl: 'iaVFFGl.jpg',
        color: 'targetLinkThreeColor',
    },
    {
        cluster: 'cluster4',
        source: 118,
        target: 17,
        value: 1,
        valueid: ['targetab', 'repeb'],
        paperName: 'LWW13',
        process: 'LWW13_4',
        id: 'LWW13-5',
        imgUrl: 'iaVFFGl.jpg',
        color: 'targetLinkThreeColor',
    },
    {
        cluster: 'cluster4',
        source: 118,
        target: 18,
        value: 1,
        valueid: ['targetab', 'repeb'],
        paperName: 'LWW13',
        process: 'LWW13_4',
        id: 'LWW13-6',
        imgUrl: 'iaVFFGl.jpg',
        color: 'targetLinkThreeColor',
    },
    {
        cluster: 'cluster4',
        source: 11,
        target: 49,
        value: 1,
        valueid: ['targetab', 'repeb'],
        paperName: 'LWW13',
        process: 'LWW13_3',
        id: 'LWW13-13',
        imgUrl: 'iaVFFGl.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 16,
        target: 49,
        value: 1,
        valueid: ['targetab', 'repeb'],
        paperName: 'LWW13',
        process: 'LWW13_4',
        id: 'LWW13-14',
        imgUrl: 'iaVFFGl.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 17,
        target: 49,
        value: 1,
        valueid: ['targetab', 'repeb'],
        paperName: 'LWW13',
        process: 'LWW13_4',
        id: 'LWW13-15',
        imgUrl: 'iaVFFGl.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 18,
        target: 49,
        value: 1,
        valueid: ['targetab', 'repeb'],
        paperName: 'LWW13',
        process: 'LWW13_4',
        id: 'LWW13-16',
        imgUrl: 'iaVFFGl.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 49,
        target: 59,
        value: 1,
        valueid: ['targetab', 'repeb'],
        paperName: 'LWW13',
        process: 'LWW13_3',
        id: 'LWW13-19',
        imgUrl: 'iaVFFGl.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 49,
        target: 59,
        value: 1,
        valueid: ['targetab', 'repeb'],
        paperName: 'LWW13',
        process: 'LWW13_4',
        id: 'LWW13-20',
        imgUrl: 'iaVFFGl.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { cluster: 'cluster4', source: 59, target: 77, value: 1, valueid: ['targetab', 'repeb'], paperName: 'LWW13', process: 'LWW13_4', id: 'LWW13-23', imgUrl: 'iaVFFGl.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 59, target: 78, value: 1, valueid: ['targetab', 'repeb'], paperName: 'LWW13', process: 'LWW13_3', id: 'LWW13-24', imgUrl: 'iaVFFGl.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 59, target: 79, value: 1, valueid: ['targetab', 'repeb'], paperName: 'LWW13', process: 'LWW13_3', id: 'LWW13-27', imgUrl: 'iaVFFGl.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 59, target: 80, value: 1, valueid: ['targetab', 'repeb'], paperName: 'LWW13', process: 'LWW13_3', id: 'LWW13-29', imgUrl: 'iaVFFGl.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 120, target: 7, value: 1, valueid: ['targetca', 'repb'], paperName: 'MDD10', process: 'MDD10_1', id: 'MDD10-0', imgUrl: 'AA3ZOvl.png', color: 'targetLinkColor' },
    { cluster: 'cluster4', source: 120, target: 22, value: 1, valueid: 'repf', paperName: 'MDD10', process: 'MDD10_6', id: 'MDD10-5', imgUrl: 'AA3ZOvl.png', color: 'targetLinkFourColor' },
    {
        cluster: 'cluster4',
        source: 7,
        target: 49,
        value: 1,
        valueid: ['targetca', 'repb'],
        paperName: 'MDD10',
        process: 'MDD10_1',
        id: 'MDD10-9',
        imgUrl: 'AA3ZOvl.png',
        color: 'intFiveLight2LinkColor',
    },
    { cluster: 'cluster4', source: 54, target: 77, value: 1, valueid: ['targetca', 'repb'], paperName: 'MDD10', process: 'MDD10_1', id: 'MDD10-17', imgUrl: 'AA3ZOvl.png', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 54, target: 78, value: 1, valueid: ['targetca', 'repb'], paperName: 'MDD10', process: 'MDD10_1', id: 'MDD10-19', imgUrl: 'AA3ZOvl.png', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 54, target: 86, value: 1, valueid: ['targetca', 'repb'], paperName: 'MDD10', process: 'MDD10_1', id: 'MDD10-22', imgUrl: 'AA3ZOvl.png', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 22, target: 49, value: 1, valueid: 'repf', paperName: 'MDD10', process: 'MDD10_6', id: 'MDD10-29', imgUrl: 'AA3ZOvl.png', color: 'intFiveLight2LinkColor' },
    {
        cluster: 'cluster4',
        source: 49,
        target: 54,
        value: 1,
        valueid: ['targetca', 'repb'],
        paperName: 'MDD10',
        process: 'MDD10_1',
        id: 'MDD10-33',
        imgUrl: 'AA3ZOvl.png',
        color: 'intFiveLight2LinkColor',
    },
    { cluster: 'cluster4', source: 49, target: 60, value: 1, valueid: 'repf', paperName: 'MDD10', process: 'MDD10_6', id: 'MDD10-34', imgUrl: 'AA3ZOvl.png', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 60, target: 98, value: 1, valueid: 'repf', paperName: 'MDD10', process: 'MDD10_6', id: 'MDD10-35', imgUrl: 'AA3ZOvl.png', color: 'repVisTechColor' },
    {
        cluster: 'cluster4',
        source: 11,
        target: 49,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'MHK16',
        process: 'MHK16_1',
        id: 'MHK16-6',
        imgUrl: 'Ak8KSur.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 12,
        target: 49,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'MHK16',
        process: 'MHK16_1',
        id: 'MHK16-7',
        imgUrl: 'Ak8KSur.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 49,
        target: 53,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'MHK16',
        process: 'MHK16_1',
        id: 'MHK16-10',
        imgUrl: 'Ak8KSur.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { cluster: 'cluster4', source: 123, target: 2, value: 1, valueid: 'targetca', paperName: 'MVM17', process: 'MVM17_1', id: 'MVM17-0', imgUrl: 'U35x588.png', color: 'targetLinkColor' },

    { cluster: 'cluster4', source: 123, target: 7, value: 1, valueid: 'targetca', paperName: 'MVM17', process: 'MVM17_1', id: 'MVM17-2', imgUrl: 'U35x588.png', color: 'targetLinkColor' },
    {
        cluster: 'cluster4',
        source: 123,
        target: 17,
        value: 1,
        valueid: ['repd', 'targetca'],
        paperName: 'MVM17',
        process: 'MVM17_2',
        id: 'MVM17-3',
        imgUrl: 'U35x588.png',
        color: 'targetLinkThreeColor',
    },
    {
        cluster: 'cluster4',
        source: 123,
        target: 19,
        value: 1,
        valueid: ['repd', 'targetca'],
        paperName: 'MVM17',
        process: 'MVM17_2',
        id: 'MVM17-4',
        imgUrl: 'U35x588.png',
        color: 'targetLinkThreeColor',
    },
    { cluster: 'cluster4', source: 2, target: 49, value: 1, valueid: 'targetca', paperName: 'MVM17', process: 'MVM17_1', id: 'MVM17-11', imgUrl: 'U35x588.png', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 4, target: 49, value: 1, valueid: 'targetca', paperName: 'MVM17', process: 'MVM17_1', id: 'MVM17-12', imgUrl: 'U35x588.png', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 7, target: 49, value: 1, valueid: 'targetca', paperName: 'MVM17', process: 'MVM17_1', id: 'MVM17-13', imgUrl: 'U35x588.png', color: 'intFiveLight2LinkColor' },
    {
        cluster: 'cluster4',
        source: 17,
        target: 49,
        value: 1,
        valueid: ['repd', 'targetca'],
        paperName: 'MVM17',
        process: 'MVM17_2',
        id: 'MVM17-15',
        imgUrl: 'U35x588.png',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 19,
        target: 49,
        value: 1,
        valueid: ['repd', 'targetca'],
        paperName: 'MVM17',
        process: 'MVM17_2',
        id: 'MVM17-17',
        imgUrl: 'U35x588.png',
        color: 'intFiveLight2LinkColor',
    },
    { cluster: 'cluster4', source: 49, target: 60, value: 1, valueid: 'targetca', paperName: 'MVM17', process: 'MVM17_1', id: 'MVM17-23', imgUrl: 'U35x588.png', color: 'intFiveLight2LinkColor' },
    {
        cluster: 'cluster4',
        source: 49,
        target: 55,
        value: 1,
        valueid: ['repd', 'targetca'],
        paperName: 'MVM17',
        process: 'MVM17_2',
        id: 'MVM17-25',
        imgUrl: 'U35x588.png',
        color: 'intFiveLight2LinkColor',
    },
    { cluster: 'cluster4', source: 60, target: 78, value: 1, valueid: 'targetca', paperName: 'MVM17', process: 'MVM17_1', id: 'MVM17-27', imgUrl: 'U35x588.png', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 55, target: 76, value: 1, valueid: ['repd', 'targetca'], paperName: 'MVM17', process: 'MVM17_2', id: 'MVM17-28', imgUrl: 'U35x588.png', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 55, target: 78, value: 1, valueid: ['repd', 'targetca'], paperName: 'MVM17', process: 'MVM17_2', id: 'MVM17-29', imgUrl: 'U35x588.png', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 55, target: 85, value: 1, valueid: ['repd', 'targetca'], paperName: 'MVM17', process: 'MVM17_2', id: 'MVM17-30', imgUrl: 'U35x588.png', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 60, target: 79, value: 1, valueid: 'targetca', paperName: 'MVM17', process: 'MVM17_1', id: 'MVM17-31', imgUrl: 'U35x588.png', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 125, target: 3, value: 1, valueid: ['targetab', 'repd'], paperName: 'PC15PV', process: 'PC15PV_2', id: 'PC15PV-1', imgUrl: 'AEd0LAv.jpg', color: 'targetLinkColor' },
    { cluster: 'cluster4', source: 125, target: 12, value: 1, valueid: 'targetab', paperName: 'PC15PV', process: 'PC15PV_4', id: 'PC15PV-3', imgUrl: 'AEd0LAv.jpg', color: 'targetLinkTwoColor' },
    {
        cluster: 'cluster4',
        source: 3,
        target: 49,
        value: 1,
        valueid: ['targetab', 'repd'],
        paperName: 'PC15PV',
        process: 'PC15PV_2',
        id: 'PC15PV-8',
        imgUrl: 'AEd0LAv.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { cluster: 'cluster4', source: 12, target: 49, value: 1, valueid: 'targetab', paperName: 'PC15PV', process: 'PC15PV_4', id: 'PC15PV-9', imgUrl: 'AEd0LAv.jpg', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 49, target: 52, value: 1, valueid: 'targetab', paperName: 'PC15PV', process: 'PC15PV_4', id: 'PC15PV-13', imgUrl: 'AEd0LAv.jpg', color: 'intFiveLight2LinkColor' },
    {
        cluster: 'cluster4',
        source: 49,
        target: 55,
        value: 1,
        valueid: ['targetab', 'repd'],
        paperName: 'PC15PV',
        process: 'PC15PV_3',
        id: 'PC15PV-15',
        imgUrl: 'AEd0LAv.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { cluster: 'cluster4', source: 52, target: 77, value: 1, valueid: 'targetab', paperName: 'PC15PV', process: 'PC15PV_4', id: 'PC15PV-18', imgUrl: 'AEd0LAv.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 52, target: 79, value: 1, valueid: 'targetab', paperName: 'PC15PV', process: 'PC15PV_4', id: 'PC15PV-20', imgUrl: 'AEd0LAv.jpg', color: 'repVisVarColor' },
    {
        cluster: 'cluster4',
        source: 55,
        target: 85,
        value: 1,
        valueid: ['targetab', 'repd'],
        paperName: 'PC15PV',
        process: 'PC15PV_3',
        id: 'PC15PV-22',
        imgUrl: 'AEd0LAv.jpg',
        color: 'repVisTechColor',
    },
    {
        cluster: 'cluster4',
        source: 127,
        target: 14,
        value: 1,
        valueid: ['targetcb', 'repf'],
        paperName: 'SCS16',
        process: 'SCS16_1',
        id: 'SCS16-0',
        imgUrl: 'ELyzRJL.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 127,
        target: 16,
        value: 1,
        valueid: ['targetcb', 'repf'],
        paperName: 'SCS16',
        process: 'SCS16_2',
        id: 'SCS16-1',
        imgUrl: 'ELyzRJL.jpg',
        color: 'targetLinkThreeColor',
    },
    {
        cluster: 'cluster4',
        source: 127,
        target: 16,
        value: 1,
        valueid: ['targetcb', 'repa'],
        paperName: 'SCS16',
        process: 'SCS16_3',
        id: 'SCS16-2',
        imgUrl: 'ELyzRJL.jpg',
        color: 'targetLinkThreeColor',
    },
    {
        cluster: 'cluster4',
        source: 14,
        target: 49,
        value: 1,
        valueid: ['targetcb', 'repf'],
        paperName: 'SCS16',
        process: 'SCS16_1',
        id: 'SCS16-8',
        imgUrl: 'ELyzRJL.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 49,
        target: 60,
        value: 1,
        valueid: ['targetcb', 'repf'],
        paperName: 'SCS16',
        process: 'SCS16_1',
        id: 'SCS16-11',
        imgUrl: 'ELyzRJL.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { cluster: 'cluster4', source: 60, target: 78, value: 1, valueid: ['targetcb', 'repf'], paperName: 'SCS16', process: 'SCS16_1', id: 'SCS16-12', imgUrl: 'ELyzRJL.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 60, target: 84, value: 1, valueid: ['targetcb', 'repf'], paperName: 'SCS16', process: 'SCS16_1', id: 'SCS16-13', imgUrl: 'ELyzRJL.jpg', color: 'repVisTechColor' },
    {
        cluster: 'cluster4',
        source: 16,
        target: 49,
        value: 1,
        valueid: ['targetcb', 'repf'],
        paperName: 'SCS16',
        process: 'SCS16_2',
        id: 'SCS16-16',
        imgUrl: 'ELyzRJL.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 49,
        target: 60,
        value: 1,
        valueid: ['targetcb', 'repf'],
        paperName: 'SCS16',
        process: 'SCS16_2',
        id: 'SCS16-19',
        imgUrl: 'ELyzRJL.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { cluster: 'cluster4', source: 60, target: 77, value: 1, valueid: ['targetcb', 'repf'], paperName: 'SCS16', process: 'SCS16_2', id: 'SCS16-20', imgUrl: 'ELyzRJL.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 60, target: 78, value: 1, valueid: ['targetcb', 'repf'], paperName: 'SCS16', process: 'SCS16_2', id: 'SCS16-21', imgUrl: 'ELyzRJL.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 60, target: 84, value: 1, valueid: ['targetcb', 'repf'], paperName: 'SCS16', process: 'SCS16_2', id: 'SCS16-22', imgUrl: 'ELyzRJL.jpg', color: 'repVisTechColor' },
    {
        cluster: 'cluster4',
        source: 16,
        target: 49,
        value: 1,
        valueid: ['targetcb', 'repa'],
        paperName: 'SCS16',
        process: 'SCS16_3',
        id: 'SCS16-25',
        imgUrl: 'ELyzRJL.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 49,
        target: 63,
        value: 1,
        valueid: ['targetcb', 'repa'],
        paperName: 'SCS16',
        process: 'SCS16_3',
        id: 'SCS16-28',
        imgUrl: 'ELyzRJL.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { cluster: 'cluster4', source: 63, target: 77, value: 1, valueid: ['targetcb', 'repa'], paperName: 'SCS16', process: 'SCS16_3', id: 'SCS16-29', imgUrl: 'ELyzRJL.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 63, target: 78, value: 1, valueid: ['targetcb', 'repa'], paperName: 'SCS16', process: 'SCS16_3', id: 'SCS16-30', imgUrl: 'ELyzRJL.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 63, target: 84, value: 1, valueid: ['targetcb', 'repa'], paperName: 'SCS16', process: 'SCS16_3', id: 'SCS16-31', imgUrl: 'ELyzRJL.jpg', color: 'repVisTechColor' },
    {
        cluster: 'cluster4',
        source: 129,
        target: 16,
        value: 1,
        valueid: ['targetcb', 'repa'],
        paperName: 'SCS19',
        process: 'SCS19_6',
        id: 'SCS19-6',
        imgUrl: 'kl0Dozw.jpg',
        color: 'targetLinkThreeColor',
    },
    {
        cluster: 'cluster4',
        source: 129,
        target: 18,
        value: 1,
        valueid: ['targetcb', 'repa'],
        paperName: 'SCS19',
        process: 'SCS19_6',
        id: 'SCS19-7',
        imgUrl: 'kl0Dozw.jpg',
        color: 'targetLinkThreeColor',
    },
    {
        cluster: 'cluster4',
        source: 16,
        target: 49,
        value: 1,
        valueid: ['targetcb', 'repa'],
        paperName: 'SCS19',
        process: 'SCS19_6',
        id: 'SCS19-32',
        imgUrl: 'kl0Dozw.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 18,
        target: 49,
        value: 1,
        valueid: ['targetcb', 'repa'],
        paperName: 'SCS19',
        process: 'SCS19_6',
        id: 'SCS19-33',
        imgUrl: 'kl0Dozw.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 49,
        target: 73,
        value: 1,
        valueid: ['targetcb', 'repa'],
        paperName: 'SCS19',
        process: 'SCS19_6',
        id: 'SCS19-34',
        imgUrl: 'kl0Dozw.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { cluster: 'cluster4', source: 73, target: 98, value: 1, valueid: ['targetcb', 'repa'], paperName: 'SCS19', process: 'SCS19_6', id: 'SCS19-35', imgUrl: 'kl0Dozw.jpg', color: 'repVisTechColor' },
    {
        cluster: 'cluster4',
        source: 131,
        target: 21,
        value: 1,
        valueid: ['targetcb', 'repf'],
        paperName: 'VWH13',
        process: 'VWH13_4',
        id: 'VWH13-7',
        imgUrl: 'TO07ZUT.jpg',
        color: 'targetLinkFourColor',
    },

    {
        cluster: 'cluster4',
        source: 21,
        target: 49,
        value: 1,
        valueid: ['targetcb', 'repc'],
        paperName: 'VWH13',
        process: 'VWH13_3',
        id: 'VWH13-27',
        imgUrl: 'TO07ZUT.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 23,
        target: 49,
        value: 1,
        valueid: ['targetcb', 'repc'],
        paperName: 'VWH13',
        process: 'VWH13_3',
        id: 'VWH13-30',
        imgUrl: 'TO07ZUT.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 49,
        target: 53,
        value: 1,
        valueid: ['targetcb', 'repc'],
        paperName: 'VWH13',
        process: 'VWH13_3',
        id: 'VWH13-33',
        imgUrl: 'TO07ZUT.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { cluster: 'cluster4', source: 53, target: 77, value: 1, valueid: ['targetcb', 'repc'], paperName: 'VWH13', process: 'VWH13_3', id: 'VWH13-34', imgUrl: 'TO07ZUT.jpg', color: 'repVisVarColor' },
    {
        cluster: 'cluster4',
        source: 21,
        target: 49,
        value: 1,
        valueid: ['targetcb', 'repf'],
        paperName: 'VWH13',
        process: 'VWH13_4',
        id: 'VWH13-40',
        imgUrl: 'TO07ZUT.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 23,
        target: 49,
        value: 1,
        valueid: ['targetcb', 'repf'],
        paperName: 'VWH13',
        process: 'VWH13_4',
        id: 'VWH13-41',
        imgUrl: 'TO07ZUT.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 49,
        target: 60,
        value: 1,
        valueid: ['targetcb', 'repf'],
        paperName: 'VWH13',
        process: 'VWH13_4',
        id: 'VWH13-44',
        imgUrl: 'TO07ZUT.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { cluster: 'cluster4', source: 60, target: 81, value: 1, valueid: ['targetcb', 'repf'], paperName: 'VWH13', process: 'VWH13_4', id: 'VWH13-45', imgUrl: 'TO07ZUT.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 60, target: 84, value: 1, valueid: ['targetcb', 'repf'], paperName: 'VWH13', process: 'VWH13_4', id: 'VWH13-46', imgUrl: 'TO07ZUT.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 60, target: 98, value: 1, valueid: ['targetcb', 'repf'], paperName: 'VWH13', process: 'VWH13_4', id: 'VWH13-47', imgUrl: 'TO07ZUT.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 133, target: 6, value: 1, valueid: 'targetba', paperName: 'XWL17', process: 'XWL17_4', id: 'XWL17-1', imgUrl: 'VqSzaXU.jpg', color: 'targetLinkColor' },
    { cluster: 'cluster4', source: 133, target: 16, value: 1, valueid: 'targetba', paperName: 'XWL17', process: 'XWL17_4', id: 'XWL17-4', imgUrl: 'VqSzaXU.jpg', color: 'targetLinkThreeColor' },
    { cluster: 'cluster4', source: 6, target: 49, value: 1, valueid: 'targetba', paperName: 'XWL17', process: 'XWL17_4', id: 'XWL17-6', imgUrl: 'VqSzaXU.jpg', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 16, target: 49, value: 1, valueid: 'targetba', paperName: 'XWL17', process: 'XWL17_4', id: 'XWL17-8', imgUrl: 'VqSzaXU.jpg', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 49, target: 61, value: 1, valueid: 'targetba', paperName: 'XWL17', process: 'XWL17_4', id: 'XWL17-17', imgUrl: 'VqSzaXU.jpg', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 61, target: 84, value: 1, valueid: 'targetba', paperName: 'XWL17', process: 'XWL17_4', id: 'XWL17-18', imgUrl: 'VqSzaXU.jpg', color: 'repVisTechColor' },
    {
        cluster: 'cluster4',
        source: 134,
        target: 11,
        value: 1,
        valueid: ['targetab', 'repc'],
        paperName: 'XWS16',
        process: 'XWS16_4',
        id: 'XWS16-1',
        imgUrl: 'xn5MqwV.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 11,
        target: 49,
        value: 1,
        valueid: ['targetab', 'repc'],
        paperName: 'XWS16',
        process: 'XWS16_4',
        id: 'XWS16-11',
        imgUrl: 'xn5MqwV.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 49,
        target: 53,
        value: 1,
        valueid: ['targetab', 'repc'],
        paperName: 'XWS16',
        process: 'XWS16_4',
        id: 'XWS16-19',
        imgUrl: 'xn5MqwV.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { cluster: 'cluster4', source: 53, target: 77, value: 1, valueid: ['targetab', 'repc'], paperName: 'XWS16', process: 'XWS16_4', id: 'XWS16-24', imgUrl: 'xn5MqwV.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 53, target: 79, value: 1, valueid: ['targetab', 'repc'], paperName: 'XWS16', process: 'XWS16_4', id: 'XWS16-28', imgUrl: 'xn5MqwV.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 53, target: 81, value: 1, valueid: ['targetab', 'repc'], paperName: 'XWS16', process: 'XWS16_4', id: 'XWS16-30', imgUrl: 'xn5MqwV.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 136, target: 15, value: 1, valueid: 'repd', paperName: 'ZGWZ14', process: 'ZGWZ14_2', id: 'ZGWZ14-1', imgUrl: 'R9fi5QW.png', color: 'targetLinkTwoColor' },
    { cluster: 'cluster4', source: 15, target: 49, value: 1, valueid: 'repd', paperName: 'ZGWZ14', process: 'ZGWZ14_2', id: 'ZGWZ14-9', imgUrl: 'R9fi5QW.png', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 49, target: 55, value: 1, valueid: 'repd', paperName: 'ZGWZ14', process: 'ZGWZ14_2', id: 'ZGWZ14-19', imgUrl: 'R9fi5QW.png', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 55, target: 77, value: 1, valueid: 'repd', paperName: 'ZGWZ14', process: 'ZGWZ14_2', id: 'ZGWZ14-25', imgUrl: 'R9fi5QW.png', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 55, target: 81, value: 1, valueid: 'repd', paperName: 'ZGWZ14', process: 'ZGWZ14_2', id: 'ZGWZ14-26', imgUrl: 'R9fi5QW.png', color: 'repVisVarColor' },
    {
        cluster: 'cluster4',
        source: 138,
        target: 11,
        value: 1,
        valueid: ['repd ', 'targetca'],
        paperName: 'SRJ13',
        process: 'SRJ13_2',
        id: 'SRJ13-1',
        imgUrl: 'kgWl7nV.png',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 138,
        target: 16,
        value: 1,
        valueid: ['repd ', 'targetca'],
        paperName: 'SRJ13',
        process: 'SRJ13_2',
        id: 'SRJ13-2',
        imgUrl: 'kgWl7nV.png',
        color: 'targetLinkThreeColor',
    },
    {
        cluster: 'cluster4',
        source: 11,
        target: 49,
        value: 1,
        valueid: ['repd ', 'targetca'],
        paperName: 'SRJ13',
        process: 'SRJ13_2',
        id: 'SRJ13-5',
        imgUrl: 'kgWl7nV.png',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 16,
        target: 49,
        value: 1,
        valueid: ['repd ', 'targetca'],
        paperName: 'SRJ13',
        process: 'SRJ13_2',
        id: 'SRJ13-6',
        imgUrl: 'kgWl7nV.png',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 49,
        target: 55,
        value: 1,
        valueid: ['repd ', 'targetca'],
        paperName: 'SRJ13',
        process: 'SRJ13_2',
        id: 'SRJ13-9',
        imgUrl: 'kgWl7nV.png',
        color: 'intFiveLight2LinkColor',
    },
    { cluster: 'cluster4', source: 55, target: 79, value: 1, valueid: ['repd ', 'targetca'], paperName: 'SRJ13', process: 'SRJ13_2', id: 'SRJ13-12', imgUrl: 'kgWl7nV.png', color: 'repVisVarColor' },
    {
        cluster: 'cluster4',
        source: 140,
        target: 15,
        value: 1,
        valueid: ['repea', ' targetca'],
        paperName: 'FAKM15',
        process: 'FAKM15_2',
        id: 'FAKM15-7',
        imgUrl: 'u2sWSNe.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 15,
        target: 49,
        value: 1,
        valueid: ['repea', ' targetca'],
        paperName: 'FAKM15',
        process: 'FAKM15_2',
        id: 'FAKM15-8',
        imgUrl: 'u2sWSNe.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 49,
        target: 59,
        value: 1,
        valueid: ['repea', ' targetca'],
        paperName: 'FAKM15',
        process: 'FAKM15_2',
        id: 'FAKM15-9',
        imgUrl: 'u2sWSNe.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 59,
        target: 78,
        value: 1,
        valueid: ['repea', ' targetca'],
        paperName: 'FAKM15',
        process: 'FAKM15_2',
        id: 'FAKM15-10',
        imgUrl: 'u2sWSNe.jpg',
        color: 'repVisVarColor',
    },
    {
        cluster: 'cluster4',
        source: 59,
        target: 80,
        value: 1,
        valueid: ['repea', ' targetca'],
        paperName: 'FAKM15',
        process: 'FAKM15_2',
        id: 'FAKM15-11',
        imgUrl: 'u2sWSNe.jpg',
        color: 'repVisVarColor',
    },
    {
        cluster: 'cluster4',
        source: 59,
        target: 88,
        value: 1,
        valueid: ['repea', ' targetca'],
        paperName: 'FAKM15',
        process: 'FAKM15_2',
        id: 'FAKM15-12',
        imgUrl: 'u2sWSNe.jpg',
        color: 'repVisTechColor',
    },

    { cluster: 'cluster4', source: 24, target: 49, value: 1, valueid: 'targetca', paperName: 'FAKM15', process: 'FAKM15_3', id: 'FAKM15-15', imgUrl: 'u2sWSNe.jpg', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 49, target: 75, value: 1, valueid: 'targetca', paperName: 'FAKM15', process: 'FAKM15_3', id: 'FAKM15-17', imgUrl: 'u2sWSNe.jpg', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 144, target: 7, value: 1, valueid: ['targetca', 'repc'], paperName: 'YCC20', process: 'YCC20_2', id: 'YCC20-1', imgUrl: 'RYq4EGR.jpg', color: 'targetLinkColor' },

    {
        cluster: 'cluster4',
        source: 7,
        target: 49,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'YCC20',
        process: 'YCC20_2',
        id: 'YCC20-7',
        imgUrl: 'RYq4EGR.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 11,
        target: 49,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'YCC20',
        process: 'YCC20_4',
        id: 'YCC20-13',
        imgUrl: 'RYq4EGR.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 49,
        target: 53,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'YCC20',
        process: 'YCC20_2',
        id: 'YCC20-16',
        imgUrl: 'RYq4EGR.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 49,
        target: 53,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'YCC20',
        process: 'YCC20_4',
        id: 'YCC20-17',
        imgUrl: 'RYq4EGR.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 49,
        target: 53,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'YCC20',
        process: 'YCC20_4',
        id: 'YCC20-22',
        imgUrl: 'RYq4EGR.jpg',
        color: 'intFiveLight2LinkColor',
    },

    { cluster: 'cluster4', source: 53, target: 78, value: 1, valueid: ['targetca', 'repc'], paperName: 'YCC20', process: 'YCC20_4', id: 'YCC20-24', imgUrl: 'RYq4EGR.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 53, target: 84, value: 1, valueid: ['targetca', 'repc'], paperName: 'YCC20', process: 'YCC20_2', id: 'YCC20-27', imgUrl: 'RYq4EGR.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 53, target: 84, value: 1, valueid: ['targetca', 'repc'], paperName: 'YCC20', process: 'YCC20_4', id: 'YCC20-28', imgUrl: 'RYq4EGR.jpg', color: 'repVisTechColor' },
    {
        cluster: 'cluster4',
        source: 147,
        target: 13,
        value: 1,
        valueid: ['targetbb', 'repb'],
        paperName: 'MDJW07',
        process: 'MDJW07_4',
        id: 'MDJW07-3',
        imgUrl: 'E21AFdm.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 147,
        target: 13,
        value: 1,
        valueid: ['targetbb', 'ref'],
        paperName: 'MDJW07',
        process: 'MDJW07_5',
        id: 'MDJW07-4',
        imgUrl: 'E21AFdm.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 147,
        target: 13,
        value: 1,
        valueid: ['targetbb', 'repg'],
        paperName: 'MDJW07',
        process: 'MDJW07_6',
        id: 'MDJW07-5',
        imgUrl: 'E21AFdm.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 147,
        target: 14,
        value: 1,
        valueid: ['targetbb', 'repb'],
        paperName: 'MDJW07',
        process: 'MDJW07_7',
        id: 'MDJW07-7',
        imgUrl: 'E21AFdm.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 147,
        target: 14,
        value: 1,
        valueid: ['targetbb', 'repf'],
        paperName: 'MDJW07',
        process: 'MDJW07_8',
        id: 'MDJW07-8',
        imgUrl: 'E21AFdm.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 13,
        target: 49,
        value: 1,
        valueid: ['targetbb', 'repg'],
        paperName: 'MDJW07',
        process: 'MDJW07_4',
        id: 'MDJW07-14',
        imgUrl: 'E21AFdm.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 13,
        target: 49,
        value: 1,
        valueid: ['targetbb', 'repf'],
        paperName: 'MDJW07',
        process: 'MDJW07_5',
        id: 'MDJW07-15',
        imgUrl: 'E21AFdm.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 13,
        target: 49,
        value: 1,
        valueid: ['targetbb', 'repg'],
        paperName: 'MDJW07',
        process: 'MDJW07_6',
        id: 'MDJW07-16',
        imgUrl: 'E21AFdm.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 14,
        target: 49,
        value: 1,
        valueid: ['targetbb', 'repb'],
        paperName: 'MDJW07',
        process: 'MDJW07_7',
        id: 'MDJW07-18',
        imgUrl: 'E21AFdm.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 14,
        target: 49,
        value: 1,
        valueid: ['targetbb', 'repf'],
        paperName: 'MDJW07',
        process: 'MDJW07_8',
        id: 'MDJW07-19',
        imgUrl: 'E21AFdm.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 49,
        target: 54,
        value: 1,
        valueid: ['targetbb', 'repb'],
        paperName: 'MDJW07',
        process: 'MDJW07_4',
        id: 'MDJW07-25',
        imgUrl: 'E21AFdm.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 49,
        target: 54,
        value: 1,
        valueid: ['targetbb', 'repb'],
        paperName: 'MDJW07',
        process: 'MDJW07_7',
        id: 'MDJW07-26',
        imgUrl: 'E21AFdm.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 49,
        target: 60,
        value: 1,
        valueid: ['targetbb', 'repf'],
        paperName: 'MDJW07',
        process: 'MDJW07_5',
        id: 'MDJW07-27',
        imgUrl: 'E21AFdm.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 49,
        target: 68,
        value: 1,
        valueid: ['targetbb', 'repb'],
        paperName: 'MDJW07',
        process: 'MDJW07_4',
        id: 'MDJW07-28',
        imgUrl: 'E21AFdm.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { cluster: 'cluster4', source: 54, target: 77, value: 1, valueid: ['targetbb', 'repb'], paperName: 'MDJW07', process: 'MDJW07_4', id: 'MDJW07-30', imgUrl: 'E21AFdm.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 54, target: 77, value: 1, valueid: ['targetbb', 'repb'], paperName: 'MDJW07', process: 'MDJW07_7', id: 'MDJW07-31', imgUrl: 'E21AFdm.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 54, target: 78, value: 1, valueid: ['targetbb', 'repb'], paperName: 'MDJW07', process: 'MDJW07_4', id: 'MDJW07-33', imgUrl: 'E21AFdm.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 60, target: 77, value: 1, valueid: ['targetbb', 'repf'], paperName: 'MDJW07', process: 'MDJW07_5', id: 'MDJW07-34', imgUrl: 'E21AFdm.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 60, target: 81, value: 1, valueid: ['targetbb', 'repf'], paperName: 'MDJW07', process: 'MDJW07_5', id: 'MDJW07-36', imgUrl: 'E21AFdm.jpg', color: 'repVisVarColor' },
    {
        cluster: 'cluster4',
        source: 54,
        target: 86,
        value: 1,
        valueid: ['targetbb', 'repb'],
        paperName: 'MDJW07',
        process: 'MDJW07_4',
        id: 'MDJW07-38',
        imgUrl: 'E21AFdm.jpg',
        color: 'repVisTechColor',
    },
    {
        cluster: 'cluster4',
        source: 54,
        target: 86,
        value: 1,
        valueid: ['targetbb', 'repb'],
        paperName: 'MDJW07',
        process: 'MDJW07_7',
        id: 'MDJW07-39',
        imgUrl: 'E21AFdm.jpg',
        color: 'repVisTechColor',
    },
    {
        cluster: 'cluster4',
        source: 54,
        target: 98,
        value: 1,
        valueid: ['targetbb', 'repb'],
        paperName: 'MDJW07',
        process: 'MDJW07_4',
        id: 'MDJW07-40',
        imgUrl: 'E21AFdm.jpg',
        color: 'repVisTechColor',
    },
    { cluster: 'cluster4', source: 149, target: 15, value: 1, valueid: 'repeb', paperName: 'BN11B', process: 'BN11B_2', id: 'BN11B-1', imgUrl: 'PfZa19T.jpg', color: 'targetLinkTwoColor' },
    { cluster: 'cluster4', source: 149, target: 24, value: 1, valueid: 'repeb', paperName: 'BN11B', process: 'BN11B_2', id: 'BN11B-2', imgUrl: 'PfZa19T.jpg', color: 'targetLinkFourColor' },
    { cluster: 'cluster4', source: 149, target: 20, value: 1, valueid: 'repf', paperName: 'BN11B', process: 'BN11B_3', id: 'BN11B-3', imgUrl: 'PfZa19T.jpg', color: 'targetLinkThreeColor' },
    { cluster: 'cluster4', source: 15, target: 49, value: 1, valueid: 'repeb', paperName: 'BN11B', process: 'BN11B_2', id: 'BN11B-7', imgUrl: 'PfZa19T.jpg', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 24, target: 49, value: 1, valueid: 'repeb', paperName: 'BN11B', process: 'BN11B_2', id: 'BN11B-8', imgUrl: 'PfZa19T.jpg', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 49, target: 75, value: 1, valueid: 'repeb', paperName: 'BN11B', process: 'BN11B_2', id: 'BN11B-9', imgUrl: 'PfZa19T.jpg', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 75, target: 98, value: 1, valueid: 'repeb', paperName: 'BN11B', process: 'BN11B_2', id: 'BN11B-10', imgUrl: 'PfZa19T.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 20, target: 49, value: 1, valueid: 'repf', paperName: 'BN11B', process: 'BN11B_3', id: 'BN11B-12', imgUrl: 'PfZa19T.jpg', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 49, target: 60, value: 1, valueid: 'repf', paperName: 'BN11B', process: 'BN11B_3', id: 'BN11B-14', imgUrl: 'PfZa19T.jpg', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 60, target: 77, value: 1, valueid: 'repf', paperName: 'BN11B', process: 'BN11B_3', id: 'BN11B-15', imgUrl: 'PfZa19T.jpg', color: 'repVisVarColor' },
    {
        cluster: 'cluster4',
        source: 150,
        target: 12,
        value: 1,
        valueid: ['targetba', 'repc'],
        paperName: 'MLG06',
        process: 'MLG06_2',
        id: 'MLG06-1',
        imgUrl: 'qXOBST8.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 12,
        target: 49,
        value: 1,
        valueid: ['targetba', 'repc'],
        paperName: 'MLG06',
        process: 'MLG06_2',
        id: 'MLG06-5',
        imgUrl: 'qXOBST8.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 49,
        target: 53,
        value: 1,
        valueid: ['targetba', 'repc'],
        paperName: 'MLG06',
        process: 'MLG06_2',
        id: 'MLG06-9',
        imgUrl: 'qXOBST8.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { cluster: 'cluster4', source: 53, target: 76, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_2', id: 'MLG06-11', imgUrl: 'qXOBST8.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 53, target: 77, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_2', id: 'MLG06-13', imgUrl: 'qXOBST8.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 53, target: 78, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_2', id: 'MLG06-15', imgUrl: 'qXOBST8.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 53, target: 82, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_2', id: 'MLG06-17', imgUrl: 'qXOBST8.jpg', color: 'repVisVarColor' },
    {
        cluster: 'cluster4',
        source: 151,
        target: 11,
        value: 1,
        valueid: ['repea', 'targetba', 'targetbb'],
        paperName: 'FA20',
        process: 'FA20_1',
        id: 'FA20-0',
        imgUrl: '2VPQbry.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 151,
        target: 12,
        value: 1,
        valueid: ['repea', 'targetba', 'targetbb'],
        paperName: 'FA20',
        process: 'FA20_1',
        id: 'FA20-1',
        imgUrl: '2VPQbry.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 151,
        target: 13,
        value: 1,
        valueid: ['repea', 'targetba', 'targetbb'],
        paperName: 'FA20',
        process: 'FA20_1',
        id: 'FA20-2',
        imgUrl: '2VPQbry.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 151,
        target: 14,
        value: 1,
        valueid: ['repea', 'targetba', 'targetbb'],
        paperName: 'FA20',
        process: 'FA20_1',
        id: 'FA20-3',
        imgUrl: '2VPQbry.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 151,
        target: 15,
        value: 1,
        valueid: ['repea', 'targetba', 'targetbb'],
        paperName: 'FA20',
        process: 'FA20_1',
        id: 'FA20-4',
        imgUrl: '2VPQbry.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 11,
        target: 49,
        value: 1,
        valueid: ['repea', 'targetba', 'targetbb'],
        paperName: 'FA20',
        process: 'FA20_1',
        id: 'FA20-6',
        imgUrl: '2VPQbry.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 12,
        target: 49,
        value: 1,
        valueid: ['repea', 'targetba', 'targetbb'],
        paperName: 'FA20',
        process: 'FA20_1',
        id: 'FA20-7',
        imgUrl: '2VPQbry.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 13,
        target: 49,
        value: 1,
        valueid: ['repea', 'targetba', 'targetbb'],
        paperName: 'FA20',
        process: 'FA20_1',
        id: 'FA20-8',
        imgUrl: '2VPQbry.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 14,
        target: 49,
        value: 1,
        valueid: ['repea', 'targetba', 'targetbb'],
        paperName: 'FA20',
        process: 'FA20_1',
        id: 'FA20-9',
        imgUrl: '2VPQbry.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 15,
        target: 49,
        value: 1,
        valueid: ['repea', 'targetba', 'targetbb'],
        paperName: 'FA20',
        process: 'FA20_1',
        id: 'FA20-10',
        imgUrl: '2VPQbry.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 49,
        target: 59,
        value: 1,
        valueid: ['repea', 'targetba', 'targetbb'],
        paperName: 'FA20',
        process: 'FA20_1',
        id: 'FA20-19',
        imgUrl: '2VPQbry.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 59,
        target: 77,
        value: 1,
        valueid: ['repea', 'targetba', 'targetbb'],
        paperName: 'FA20',
        process: 'FA20_1',
        id: 'FA20-20',
        imgUrl: '2VPQbry.jpg',
        color: 'repVisVarColor',
    },
    { cluster: 'cluster4', source: 152, target: 0, value: 1, valueid: ['repf', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_3', id: 'WHWS12-6', imgUrl: 'sp1TtaX.jpg', color: 'targetLinkColor' },
    { cluster: 'cluster4', source: 152, target: 3, value: 1, valueid: ['repf', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_3', id: 'WHWS12-7', imgUrl: 'sp1TtaX.jpg', color: 'targetLinkColor' },
    { cluster: 'cluster4', source: 152, target: 6, value: 1, valueid: ['repf', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_3', id: 'WHWS12-8', imgUrl: 'sp1TtaX.jpg', color: 'targetLinkColor' },
    { cluster: 'cluster4', source: 152, target: 0, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_4', id: 'WHWS12-9', imgUrl: 'sp1TtaX.jpg', color: 'targetLinkColor' },
    {
        cluster: 'cluster4',
        source: 152,
        target: 3,
        value: 1,
        valueid: ['repg', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_4',
        id: 'WHWS12-10',
        imgUrl: 'sp1TtaX.jpg',
        color: 'targetLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 152,
        target: 6,
        value: 1,
        valueid: ['repg', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_4',
        id: 'WHWS12-11',
        imgUrl: 'sp1TtaX.jpg',
        color: 'targetLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 0,
        target: 49,
        value: 1,
        valueid: ['repf', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_3',
        id: 'WHWS12-43',
        imgUrl: 'sp1TtaX.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 3,
        target: 49,
        value: 1,
        valueid: ['repf', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_3',
        id: 'WHWS12-44',
        imgUrl: 'sp1TtaX.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 6,
        target: 49,
        value: 1,
        valueid: ['repf', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_3',
        id: 'WHWS12-45',
        imgUrl: 'sp1TtaX.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 49,
        target: 60,
        value: 1,
        valueid: ['repf', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_3',
        id: 'WHWS12-46',
        imgUrl: 'sp1TtaX.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { cluster: 'cluster4', source: 60, target: 76, value: 1, valueid: ['repf', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_3', id: 'WHWS12-47', imgUrl: 'sp1TtaX.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 60, target: 77, value: 1, valueid: ['repf', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_3', id: 'WHWS12-48', imgUrl: 'sp1TtaX.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 60, target: 78, value: 1, valueid: ['repf', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_3', id: 'WHWS12-49', imgUrl: 'sp1TtaX.jpg', color: 'repVisVarColor' },
    {
        cluster: 'cluster4',
        source: 0,
        target: 49,
        value: 1,
        valueid: ['repg', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_4',
        id: 'WHWS12-50',
        imgUrl: 'sp1TtaX.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 3,
        target: 49,
        value: 1,
        valueid: ['repg', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_4',
        id: 'WHWS12-51',
        imgUrl: 'sp1TtaX.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 6,
        target: 49,
        value: 1,
        valueid: ['repg', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_4',
        id: 'WHWS12-52',
        imgUrl: 'sp1TtaX.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 49,
        target: 68,
        value: 1,
        valueid: ['repg', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_4',
        id: 'WHWS12-53',
        imgUrl: 'sp1TtaX.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { cluster: 'cluster4', source: 68, target: 76, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_4', id: 'WHWS12-54', imgUrl: 'sp1TtaX.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 68, target: 77, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_4', id: 'WHWS12-55', imgUrl: 'sp1TtaX.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 68, target: 78, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_4', id: 'WHWS12-56', imgUrl: 'sp1TtaX.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 153, target: 23, value: 1, valueid: 'repf', paperName: 'FZC18', process: 'FZC18_7', id: 'FZC18-8', imgUrl: 'zz8t6eU.jpg', color: 'targetLinkFourColor' },
    { cluster: 'cluster4', source: 23, target: 49, value: 1, valueid: 'repf', paperName: 'FZC18', process: 'FZC18_7', id: 'FZC18-33', imgUrl: 'zz8t6eU.jpg', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 49, target: 60, value: 1, valueid: 'repf', paperName: 'FZC18', process: 'FZC18_7', id: 'FZC18-34', imgUrl: 'zz8t6eU.jpg', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 60, target: 98, value: 1, valueid: 'repf', paperName: 'FZC18', process: 'FZC18_7', id: 'FZC18-35', imgUrl: 'zz8t6eU.jpg', color: 'repVisTechColor' },
    {
        cluster: 'cluster4',
        source: 157,
        target: 11,
        value: 1,
        valueid: ['targetaa', 'repd'],
        paperName: 'SFJ16',
        process: 'SFJ16_3',
        id: 'SFJ16-6',
        imgUrl: 'e3PRKTM.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 157,
        target: 12,
        value: 1,
        valueid: ['targetaa', 'repd'],
        paperName: 'SFJ16',
        process: 'SFJ16_3',
        id: 'SFJ16-7',
        imgUrl: 'e3PRKTM.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 157,
        target: 16,
        value: 1,
        valueid: ['targetaa', 'repd'],
        paperName: 'SFJ16',
        process: 'SFJ16_3',
        id: 'SFJ16-8',
        imgUrl: 'e3PRKTM.jpg',
        color: 'targetLinkThreeColor',
    },
    {
        cluster: 'cluster4',
        source: 11,
        target: 49,
        value: 1,
        valueid: ['targetaa', 'repd'],
        paperName: 'SFJ16',
        process: 'SFJ16_3',
        id: 'SFJ16-23',
        imgUrl: 'e3PRKTM.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 12,
        target: 49,
        value: 1,
        valueid: ['targetaa', 'repd'],
        paperName: 'SFJ16',
        process: 'SFJ16_3',
        id: 'SFJ16-24',
        imgUrl: 'e3PRKTM.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 16,
        target: 49,
        value: 1,
        valueid: ['targetaa', 'repd'],
        paperName: 'SFJ16',
        process: 'SFJ16_3',
        id: 'SFJ16-25',
        imgUrl: 'e3PRKTM.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        cluster: 'cluster4',
        source: 49,
        target: 55,
        value: 1,
        valueid: ['targetaa', 'repd'],
        paperName: 'SFJ16',
        process: 'SFJ16_3',
        id: 'SFJ16-26',
        imgUrl: 'e3PRKTM.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { cluster: 'cluster4', source: 55, target: 84, value: 1, valueid: ['targetaa', 'repd'], paperName: 'SFJ16', process: 'SFJ16_3', id: 'SFJ16-27', imgUrl: 'e3PRKTM.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 55, target: 92, value: 1, valueid: ['targetaa', 'repd'], paperName: 'SFJ16', process: 'SFJ16_3', id: 'SFJ16-28', imgUrl: 'e3PRKTM.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 158, target: 5, value: 1, valueid: 'targetbb', paperName: 'XJX21', process: 'XJX21_3', id: 'XJX21-5', imgUrl: 'fv9Lvcx.jpg', color: 'targetLinkColor' },
    { cluster: 'cluster4', source: 158, target: 12, value: 1, valueid: 'targetbb', paperName: 'XJX21', process: 'XJX21_3', id: 'XJX21-6', imgUrl: 'fv9Lvcx.jpg', color: 'targetLinkTwoColor' },
    { cluster: 'cluster4', source: 5, target: 49, value: 1, valueid: 'targetbb', paperName: 'XJX21', process: 'XJX21_3', id: 'XJX21-37', imgUrl: 'fv9Lvcx.jpg', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 12, target: 49, value: 1, valueid: 'targetbb', paperName: 'XJX21', process: 'XJX21_3', id: 'XJX21-39', imgUrl: 'fv9Lvcx.jpg', color: 'intFiveLight2LinkColor' },
    { cluster: 'cluster4', source: 100, target: 24, value: 1, valueid: 'repeb', paperName: 'CAA20', process: 'CAA20_6', id: 'CAA20-5', imgUrl: 'DFBi3Mo.jpg', color: 'targetLinkFourColor' },
    { cluster: 'cluster4', source: 100, target: 24, value: 1, valueid: 'repb', paperName: 'CAA20', process: 'CAA20_7', id: 'CAA20-6', imgUrl: 'DFBi3Mo.jpg', color: 'targetLinkFourColor' },
    { cluster: 'cluster4', source: 24, target: 46, value: 1, valueid: 'repb', paperName: 'CAA20', process: 'CAA20_6', id: 'CAA20-12', imgUrl: 'DFBi3Mo.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 24, target: 46, value: 1, valueid: 'repeb', paperName: 'CAA20', process: 'CAA20_7', id: 'CAA20-13', imgUrl: 'DFBi3Mo.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 70, value: 1, valueid: 'repb', paperName: 'CAA20', process: 'CAA20_6', id: 'CAA20-19', imgUrl: 'DFBi3Mo.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 75, value: 1, valueid: 'repeb', paperName: 'CAA20', process: 'CAA20_7', id: 'CAA20-20', imgUrl: 'DFBi3Mo.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 70, target: 98, value: 1, valueid: 'repb', paperName: 'CAA20', process: 'CAA20_6', id: 'CAA20-30', imgUrl: 'DFBi3Mo.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 75, target: 98, value: 1, valueid: 'repeb', paperName: 'CAA20', process: 'CAA20_7', id: 'CAA20-31', imgUrl: 'DFBi3Mo.jpg', color: 'repVisTechColor' },
    {
        cluster: 'cluster4',
        source: 101,
        target: 15,
        value: 1,
        valueid: ['repeb', 'targetbb'],
        paperName: 'CGK21',
        process: 'CGK21_5',
        id: 'CGK21-6',
        imgUrl: 'Q201xEJ.jpg',
        color: 'targetLinkTwoColor',
    },
    { cluster: 'cluster4', source: 101, target: 23, value: 1, valueid: 'repb', paperName: 'CGK21', process: 'CGK21_8', id: 'CGK21-9', imgUrl: 'Q201xEJ.jpg', color: 'targetLinkFourColor' },
    { cluster: 'cluster4', source: 15, target: 46, value: 1, valueid: ['repb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_5', id: 'CGK21-16', imgUrl: 'Q201xEJ.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 23, target: 46, value: 1, valueid: 'repb', paperName: 'CGK21', process: 'CGK21_8', id: 'CGK21-19', imgUrl: 'Q201xEJ.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 54, value: 1, valueid: ['repb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_5', id: 'CGK21-26', imgUrl: 'Q201xEJ.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 54, value: 1, valueid: 'repb', paperName: 'CGK21', process: 'CGK21_8', id: 'CGK21-27', imgUrl: 'Q201xEJ.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 54, target: 77, value: 1, valueid: 'repb', paperName: 'CGK21', process: 'CGK21_8', id: 'CGK21-31', imgUrl: 'Q201xEJ.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 54, target: 78, value: 1, valueid: 'repb', paperName: 'CGK21', process: 'CGK21_8', id: 'CGK21-37', imgUrl: 'Q201xEJ.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 54, target: 98, value: 1, valueid: ['repb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_5', id: 'CGK21-48', imgUrl: 'Q201xEJ.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 54, target: 98, value: 1, valueid: 'repb', paperName: 'CGK21', process: 'CGK21_8', id: 'CGK21-49', imgUrl: 'Q201xEJ.jpg', color: 'repVisTechColor' },
    {
        cluster: 'cluster4',
        source: 102,
        target: 21,
        value: 1,
        valueid: ['targetcb', 'repc'],
        paperName: 'CSL12',
        process: 'CSL12_5',
        id: 'CSL12-10',
        imgUrl: 'a3kehFc.jpg',
        color: 'targetLinkFourColor',
    },
    {
        cluster: 'cluster4',
        source: 102,
        target: 21,
        value: 1,
        valueid: ['targetcb', 'repc'],
        paperName: 'CSL12',
        process: 'CSL12_6',
        id: 'CSL12-11',
        imgUrl: 'a3kehFc.jpg',
        color: 'targetLinkFourColor',
    },
    { cluster: 'cluster4', source: 21, target: 46, value: 1, valueid: ['targetcb', 'repc'], paperName: 'CSL12', process: 'CSL12_5', id: 'CSL12-23', imgUrl: 'a3kehFc.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 21, target: 46, value: 1, valueid: ['targetcb', 'repc'], paperName: 'CSL12', process: 'CSL12_6', id: 'CSL12-24', imgUrl: 'a3kehFc.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 53, value: 1, valueid: ['targetcb', 'repc'], paperName: 'CSL12', process: 'CSL12_5', id: 'CSL12-27', imgUrl: 'a3kehFc.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 70, value: 1, valueid: ['targetcb', 'repc'], paperName: 'CSL12', process: 'CSL12_6', id: 'CSL12-32', imgUrl: 'a3kehFc.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 53, target: 80, value: 1, valueid: ['targetcb', 'repc'], paperName: 'CSL12', process: 'CSL12_5', id: 'CSL12-37', imgUrl: 'a3kehFc.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 70, target: 98, value: 1, valueid: ['targetcb', 'repc'], paperName: 'CSL12', process: 'CSL12_6', id: 'CSL12-41', imgUrl: 'a3kehFc.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 104, target: 21, value: 1, valueid: 'targetcb', paperName: 'EAIA17', process: 'EAIA17_4', id: 'EAIA17-3', imgUrl: 'TFuj7MS.jpg', color: 'targetLinkFourColor' },
    { cluster: 'cluster4', source: 21, target: 46, value: 1, valueid: 'targetcb', paperName: 'EAIA17', process: 'EAIA17_4', id: 'EAIA17-11', imgUrl: 'TFuj7MS.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 52, value: 1, valueid: 'targetcb', paperName: 'EAIA17', process: 'EAIA17_4', id: 'EAIA17-19', imgUrl: 'TFuj7MS.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 52, target: 81, value: 1, valueid: 'targetcb', paperName: 'EAIA17', process: 'EAIA17_4', id: 'EAIA17-25', imgUrl: 'TFuj7MS.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 105, target: 7, value: 1, valueid: ['targetca', 'repa'], paperName: 'EYG15', process: 'EYG15_2', id: 'EYG15-1', imgUrl: '9p9Vu7Y.jpg', color: 'targetLinkColor' },
    {
        cluster: 'cluster4',
        source: 105,
        target: 21,
        value: 1,
        valueid: ['targetcb', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_6',
        id: 'EYG15-5',
        imgUrl: '9p9Vu7Y.jpg',
        color: 'targetLinkFourColor',
    },
    {
        cluster: 'cluster4',
        source: 105,
        target: 22,
        value: 1,
        valueid: ['targetcb', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_6',
        id: 'EYG15-6',
        imgUrl: '9p9Vu7Y.jpg',
        color: 'targetLinkFourColor',
    },
    { cluster: 'cluster4', source: 7, target: 46, value: 1, valueid: ['targetca', 'repa'], paperName: 'EYG15', process: 'EYG15_2', id: 'EYG15-8', imgUrl: '9p9Vu7Y.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 63, value: 1, valueid: ['targetca', 'repa'], paperName: 'EYG15', process: 'EYG15_2', id: 'EYG15-11', imgUrl: '9p9Vu7Y.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 63, target: 78, value: 1, valueid: ['targetca', 'repa'], paperName: 'EYG15', process: 'EYG15_2', id: 'EYG15-16', imgUrl: '9p9Vu7Y.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 63, target: 92, value: 1, valueid: ['targetca', 'repa'], paperName: 'EYG15', process: 'EYG15_2', id: 'EYG15-22', imgUrl: '9p9Vu7Y.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 21, target: 46, value: 1, valueid: ['targetcb', 'repa'], paperName: 'EYG15', process: 'EYG15_6', id: 'EYG15-28', imgUrl: '9p9Vu7Y.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 22, target: 46, value: 1, valueid: ['targetcb', 'repa'], paperName: 'EYG15', process: 'EYG15_6', id: 'EYG15-29', imgUrl: '9p9Vu7Y.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 75, value: 1, valueid: ['targetcb', 'repa'], paperName: 'EYG15', process: 'EYG15_6', id: 'EYG15-30', imgUrl: '9p9Vu7Y.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 75, target: 98, value: 1, valueid: ['targetcb', 'repa'], paperName: 'EYG15', process: 'EYG15_6', id: 'EYG15-31', imgUrl: '9p9Vu7Y.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 107, target: 24, value: 1, valueid: 'repc', paperName: 'GGS12MT', process: 'GGS12MT_4', id: 'GGS12MT-4', imgUrl: 'wVHfoIB.png', color: 'targetLinkFourColor' },
    { cluster: 'cluster4', source: 107, target: 28, value: 1, valueid: 'repc', paperName: 'GGS12MT', process: 'GGS12MT_4', id: 'GGS12MT-5', imgUrl: 'wVHfoIB.png', color: 'targetLinkFourColor' },
    { cluster: 'cluster4', source: 24, target: 46, value: 1, valueid: 'repc', paperName: 'GGS12MT', process: 'GGS12MT_4', id: 'GGS12MT-10', imgUrl: 'wVHfoIB.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 28, target: 46, value: 1, valueid: 'repc', paperName: 'GGS12MT', process: 'GGS12MT_4', id: 'GGS12MT-11', imgUrl: 'wVHfoIB.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 70, value: 1, valueid: 'repc', paperName: 'GGS12MT', process: 'GGS12MT_4', id: 'GGS12MT-15', imgUrl: 'wVHfoIB.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 70, target: 98, value: 1, valueid: 'repc', paperName: 'GGS12MT', process: 'GGS12MT_4', id: 'GGS12MT-19', imgUrl: 'wVHfoIB.png', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 111, target: 5, value: 1, valueid: ['targetbb', 'repb'], paperName: 'JTM11', process: 'JTM11_1', id: 'index-0', imgUrl: 'AqAwugG.png', color: 'targetLinkColor' },
    {
        cluster: 'cluster4',
        source: 111,
        target: 12,
        value: 1,
        valueid: ['targetbb', 'targetcb', 'repb'],
        paperName: 'JTM11',
        process: 'JTM11_2',
        id: 'index-1',
        imgUrl: 'AqAwugG.png',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 111,
        target: 24,
        value: 1,
        valueid: ['targetcb', 'repb'],
        paperName: 'JTM11',
        process: 'JTM11_6',
        id: 'index-7',
        imgUrl: 'AqAwugG.png',
        color: 'targetLinkFourColor',
    },
    { cluster: 'cluster4', source: 5, target: 46, value: 1, valueid: ['targetbb', 'repb'], paperName: 'JTM11', process: 'JTM11_1', id: 'index-8', imgUrl: 'AqAwugG.png', color: 'intFiveLinkColor' },
    {
        cluster: 'cluster4',
        source: 12,
        target: 46,
        value: 1,
        valueid: ['targetbb', 'targetcb', 'repb'],
        paperName: 'JTM11',
        process: 'JTM11_2',
        id: 'index-9',
        imgUrl: 'AqAwugG.png',
        color: 'intFiveLinkColor',
    },
    { cluster: 'cluster4', source: 24, target: 46, value: 1, valueid: ['targetcb', 'repb'], paperName: 'JTM11', process: 'JTM11_6', id: 'index-15', imgUrl: 'AqAwugG.png', color: 'intFiveLinkColor' },
    {
        cluster: 'cluster4',
        source: 46,
        target: 54,
        value: 1,
        valueid: ['targetbb', 'targetcb', 'repb'],
        paperName: 'JTM11',
        process: 'JTM11_2',
        id: 'index-16',
        imgUrl: 'AqAwugG.png',
        color: 'intFiveLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 54,
        target: 83,
        value: 1,
        valueid: ['targetbb', 'targetcb', 'repb'],
        paperName: 'JTM11',
        process: 'JTM11_2',
        id: 'index-19',
        imgUrl: 'AqAwugG.png',
        color: 'repVisTechColor',
    },
    {
        cluster: 'cluster4',
        source: 54,
        target: 78,
        value: 1,
        valueid: ['targetbb', 'targetcb', 'repb'],
        paperName: 'JTM11',
        process: 'JTM11_2',
        id: 'index-22',
        imgUrl: 'AqAwugG.png',
        color: 'repVisVarColor',
    },
    { cluster: 'cluster4', source: 46, target: 70, value: 1, valueid: ['targetcb', 'repb'], paperName: 'JTM11', process: 'JTM11_6', id: 'index-27', imgUrl: 'AqAwugG.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 70, value: 1, valueid: ['targetbb', 'repb'], paperName: 'JTM11', process: 'JTM11_1', id: 'index-28', imgUrl: 'AqAwugG.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 70, target: 78, value: 1, valueid: ['targetcb', 'repb'], paperName: 'JTM11', process: 'JTM11_6', id: 'index-29', imgUrl: 'AqAwugG.png', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 70, target: 98, value: 1, valueid: ['targetbb', 'repb'], paperName: 'JTM11', process: 'JTM11_1', id: 'index-30', imgUrl: 'AqAwugG.png', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 70, target: 98, value: 1, valueid: ['targetcb', 'repb'], paperName: 'JTM11', process: 'JTM11_6', id: 'index-31', imgUrl: 'AqAwugG.png', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 112, target: 22, value: 1, valueid: 'repc', paperName: 'JSM16', process: 'JSM16_3', id: 'JSM16-4', imgUrl: 'n4jwcKO.jpg', color: 'targetLinkFourColor' },
    { cluster: 'cluster4', source: 22, target: 46, value: 1, valueid: 'repc', paperName: 'JSM16', process: 'JSM16_3', id: 'JSM16-17', imgUrl: 'n4jwcKO.jpg', color: 'intFiveLinkColor' },
    {
        cluster: 'cluster4',
        source: 114,
        target: 0,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-1',
        imgUrl: 'AY0EaHs.png',
        color: 'targetLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 114,
        target: 0,
        value: 1,
        valueid: ['repf', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_3',
        id: 'KSBK15-2',
        imgUrl: 'AY0EaHs.png',
        color: 'targetLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 114,
        target: 2,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-4',
        imgUrl: 'AY0EaHs.png',
        color: 'targetLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 114,
        target: 2,
        value: 1,
        valueid: ['repf', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_3',
        id: 'KSBK15-5',
        imgUrl: 'AY0EaHs.png',
        color: 'targetLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 114,
        target: 3,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-7',
        imgUrl: 'AY0EaHs.png',
        color: 'targetLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 114,
        target: 3,
        value: 1,
        valueid: ['repf', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_3',
        id: 'KSBK15-8',
        imgUrl: 'AY0EaHs.png',
        color: 'targetLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 114,
        target: 4,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-10',
        imgUrl: 'AY0EaHs.png',
        color: 'targetLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 114,
        target: 4,
        value: 1,
        valueid: ['repf', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_3',
        id: 'KSBK15-11',
        imgUrl: 'AY0EaHs.png',
        color: 'targetLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 114,
        target: 5,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-13',
        imgUrl: 'AY0EaHs.png',
        color: 'targetLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 114,
        target: 5,
        value: 1,
        valueid: ['repf', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_3',
        id: 'KSBK15-14',
        imgUrl: 'AY0EaHs.png',
        color: 'targetLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 114,
        target: 6,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-16',
        imgUrl: 'AY0EaHs.png',
        color: 'targetLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 114,
        target: 6,
        value: 1,
        valueid: ['repf', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_3',
        id: 'KSBK15-17',
        imgUrl: 'AY0EaHs.png',
        color: 'targetLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 114,
        target: 7,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-19',
        imgUrl: 'AY0EaHs.png',
        color: 'targetLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 114,
        target: 7,
        value: 1,
        valueid: ['repf', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_3',
        id: 'KSBK15-20',
        imgUrl: 'AY0EaHs.png',
        color: 'targetLinkColor',
    },
    { cluster: 'cluster4', source: 114, target: 16, value: 1, valueid: 'repf', paperName: 'KSBK15', process: 'KSBK15_7', id: 'KSBK15-30', imgUrl: 'AY0EaHs.png', color: 'targetLinkThreeColor' },
    {
        cluster: 'cluster4',
        source: 0,
        target: 46,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-45',
        imgUrl: 'AY0EaHs.png',
        color: 'intFiveLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 2,
        target: 46,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-46',
        imgUrl: 'AY0EaHs.png',
        color: 'intFiveLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 3,
        target: 46,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-47',
        imgUrl: 'AY0EaHs.png',
        color: 'intFiveLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 4,
        target: 46,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-48',
        imgUrl: 'AY0EaHs.png',
        color: 'intFiveLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 5,
        target: 46,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-49',
        imgUrl: 'AY0EaHs.png',
        color: 'intFiveLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 6,
        target: 46,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-50',
        imgUrl: 'AY0EaHs.png',
        color: 'intFiveLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 7,
        target: 46,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-51',
        imgUrl: 'AY0EaHs.png',
        color: 'intFiveLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 0,
        target: 46,
        value: 1,
        valueid: ['repf', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_3',
        id: 'KSBK15-52',
        imgUrl: 'AY0EaHs.png',
        color: 'intFiveLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 2,
        target: 46,
        value: 1,
        valueid: ['repf', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_3',
        id: 'KSBK15-53',
        imgUrl: 'AY0EaHs.png',
        color: 'intFiveLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 3,
        target: 46,
        value: 1,
        valueid: ['repf', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_3',
        id: 'KSBK15-54',
        imgUrl: 'AY0EaHs.png',
        color: 'intFiveLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 4,
        target: 46,
        value: 1,
        valueid: ['repf', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_3',
        id: 'KSBK15-55',
        imgUrl: 'AY0EaHs.png',
        color: 'intFiveLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 5,
        target: 46,
        value: 1,
        valueid: ['repf', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_3',
        id: 'KSBK15-56',
        imgUrl: 'AY0EaHs.png',
        color: 'intFiveLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 6,
        target: 46,
        value: 1,
        valueid: ['repf', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_3',
        id: 'KSBK15-57',
        imgUrl: 'AY0EaHs.png',
        color: 'intFiveLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 7,
        target: 46,
        value: 1,
        valueid: ['repf', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_3',
        id: 'KSBK15-58',
        imgUrl: 'AY0EaHs.png',
        color: 'intFiveLinkColor',
    },
    { cluster: 'cluster4', source: 16, target: 46, value: 1, valueid: 'repf', paperName: 'KSBK15', process: 'KSBK15_7', id: 'KSBK15-78', imgUrl: 'AY0EaHs.png', color: 'intFiveLinkColor' },
    {
        cluster: 'cluster4',
        source: 46,
        target: 55,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-82',
        imgUrl: 'AY0EaHs.png',
        color: 'intFiveLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 46,
        target: 60,
        value: 1,
        valueid: ['repf', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_3',
        id: 'KSBK15-83',
        imgUrl: 'AY0EaHs.png',
        color: 'intFiveLinkColor',
    },
    { cluster: 'cluster4', source: 46, target: 60, value: 1, valueid: 'repf', paperName: 'KSBK15', process: 'KSBK15_7', id: 'KSBK15-84', imgUrl: 'AY0EaHs.png', color: 'intFiveLinkColor' },
    {
        cluster: 'cluster4',
        source: 55,
        target: 78,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-92',
        imgUrl: 'AY0EaHs.png',
        color: 'repVisVarColor',
    },
    {
        cluster: 'cluster4',
        source: 55,
        target: 84,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-93',
        imgUrl: 'AY0EaHs.png',
        color: 'repVisTechColor',
    },
    {
        cluster: 'cluster4',
        source: 55,
        target: 85,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-95',
        imgUrl: 'AY0EaHs.png',
        color: 'repVisTechColor',
    },
    {
        cluster: 'cluster4',
        source: 60,
        target: 78,
        value: 1,
        valueid: ['repf', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_3',
        id: 'KSBK15-97',
        imgUrl: 'AY0EaHs.png',
        color: 'repVisVarColor',
    },
    { cluster: 'cluster4', source: 60, target: 89, value: 1, valueid: 'repf', paperName: 'KSBK15', process: 'KSBK15_7', id: 'KSBK15-98', imgUrl: 'AY0EaHs.png', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 116, target: 23, value: 1, valueid: 'repb', paperName: 'LJC18', process: 'LJC18_9', id: 'LJC18-8', imgUrl: 'bYdgkcY.jpg', color: 'targetLinkFourColor' },
    { cluster: 'cluster4', source: 23, target: 46, value: 1, valueid: 'repb', paperName: 'LJC18', process: 'LJC18_9', id: 'LJC18-19', imgUrl: 'bYdgkcY.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 117, target: 24, value: 1, valueid: 'targetab', paperName: 'LLN14', process: 'LLN14_4', id: 'LLN14-4', imgUrl: 'xWQU5gc.jpg', color: 'targetLinkFourColor' },
    { cluster: 'cluster4', source: 117, target: 24, value: 1, valueid: 'targetab', paperName: 'LLN14', process: 'LLN14_5', id: 'LLN14-5', imgUrl: 'xWQU5gc.jpg', color: 'targetLinkFourColor' },
    { cluster: 'cluster4', source: 24, target: 46, value: 1, valueid: 'targetab', paperName: 'LLN14', process: 'LLN14_4', id: 'LLN14-21', imgUrl: 'xWQU5gc.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 55, value: 1, valueid: 'targetab', paperName: 'LLN14', process: 'LLN14_4', id: 'LLN14-22', imgUrl: 'xWQU5gc.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 55, target: 79, value: 1, valueid: 'targetab', paperName: 'LLN14', process: 'LLN14_4', id: 'LLN14-23', imgUrl: 'xWQU5gc.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 55, target: 82, value: 1, valueid: 'targetab', paperName: 'LLN14', process: 'LLN14_4', id: 'LLN14-24', imgUrl: 'xWQU5gc.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 24, target: 46, value: 1, valueid: 'targetab', paperName: 'LLN14', process: 'LLN14_5', id: 'LLN14-25', imgUrl: 'xWQU5gc.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 70, value: 1, valueid: 'targetab', paperName: 'LLN14', process: 'LLN14_5', id: 'LLN14-26', imgUrl: 'xWQU5gc.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 70, target: 98, value: 1, valueid: 'targetab', paperName: 'LLN14', process: 'LLN14_5', id: 'LLN14-27', imgUrl: 'xWQU5gc.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 46, target: 75, value: 1, valueid: 'repeb', paperName: 'LWW13', process: 'LWW13_5', id: 'LWW13-21', imgUrl: 'iaVFFGl.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 75, target: 98, value: 1, valueid: 'repeb', paperName: 'LWW13', process: 'LWW13_5', id: 'LWW13-30', imgUrl: 'iaVFFGl.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 119, target: 21, value: 1, valueid: 'repg', paperName: 'MA16', process: 'MA16_4', id: 'MA16-3', imgUrl: '69BWuDV.png', color: 'targetLinkFourColor' },
    { cluster: 'cluster4', source: 119, target: 27, value: 1, valueid: 'repg', paperName: 'MA16', process: 'MA16_4', id: 'MA16-4', imgUrl: '69BWuDV.png', color: 'targetLinkFourColor' },
    { cluster: 'cluster4', source: 21, target: 46, value: 1, valueid: 'repg', paperName: 'MA16', process: 'MA16_4', id: 'MA16-9', imgUrl: '69BWuDV.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 27, target: 46, value: 1, valueid: 'repg', paperName: 'MA16', process: 'MA16_4', id: 'MA16-10', imgUrl: '69BWuDV.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 68, value: 1, valueid: 'repg', paperName: 'MA16', process: 'MA16_4', id: 'MA16-16', imgUrl: '69BWuDV.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 68, target: 82, value: 1, valueid: 'repg', paperName: 'MA16', process: 'MA16_4', id: 'MA16-19', imgUrl: '69BWuDV.png', color: 'repVisVarColor' },
    {
        cluster: 'cluster4',
        source: 120,
        target: 11,
        value: 1,
        valueid: ['targetca', 'repf'],
        paperName: 'MDD10',
        process: 'MDD10_3',
        id: 'MDD10-2',
        imgUrl: 'AA3ZOvl.png',
        color: 'targetLinkTwoColor',
    },

    { cluster: 'cluster4', source: 120, target: 22, value: 1, valueid: 'repb', paperName: 'MDD10', process: 'MDD10_7', id: 'MDD10-6', imgUrl: 'AA3ZOvl.png', color: 'targetLinkFourColor' },
    { cluster: 'cluster4', source: 11, target: 46, value: 1, valueid: ['targetca', 'repf'], paperName: 'MDD10', process: 'MDD10_3', id: 'MDD10-8', imgUrl: 'AA3ZOvl.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 22, target: 46, value: 1, valueid: 'repb', paperName: 'MDD10', process: 'MDD10_7', id: 'MDD10-27', imgUrl: 'AA3ZOvl.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 22, target: 46, value: 1, valueid: 'repf', paperName: 'MDD10', process: 'MDD10_6', id: 'MDD10-28', imgUrl: 'AA3ZOvl.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 60, value: 1, valueid: 'repf', paperName: 'MDD10', process: 'MDD10_6', id: 'MDD10-30', imgUrl: 'AA3ZOvl.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 60, value: 1, valueid: ['targetca', 'repf'], paperName: 'MDD10', process: 'MDD10_3', id: 'MDD10-31', imgUrl: 'AA3ZOvl.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 54, value: 1, valueid: 'repb', paperName: 'MDD10', process: 'MDD10_7', id: 'MDD10-32', imgUrl: 'AA3ZOvl.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 60, target: 98, value: 1, valueid: ['targetca', 'repf'], paperName: 'MDD10', process: 'MDD10_3', id: 'MDD10-36', imgUrl: 'AA3ZOvl.png', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 121, target: 24, value: 1, valueid: 'targetaa', paperName: 'MEV16', process: 'MEV16_6', id: 'MEV16-9', imgUrl: 'FpTZ8Nt.jpg', color: 'targetLinkFourColor' },
    { cluster: 'cluster4', source: 24, target: 46, value: 1, valueid: 'targetaa', paperName: 'MEV16', process: 'MEV16_6', id: 'MEV16-35', imgUrl: 'FpTZ8Nt.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 70, value: 1, valueid: 'targetaa', paperName: 'MEV16', process: 'MEV16_6', id: 'MEV16-36', imgUrl: 'FpTZ8Nt.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 70, target: 98, value: 1, valueid: 'targetaa', paperName: 'MEV16', process: 'MEV16_6', id: 'MEV16-37', imgUrl: 'FpTZ8Nt.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 123, target: 4, value: 1, valueid: 'targetca', paperName: 'MVM17', process: 'MVM17_1', id: 'MVM17-1', imgUrl: 'U35x588.png', color: 'targetLinkColor' },
    { cluster: 'cluster4', source: 123, target: 21, value: 1, valueid: 'targetca', paperName: 'MVM17', process: 'MVM17_3', id: 'MVM17-5', imgUrl: 'U35x588.png', color: 'targetLinkFourColor' },
    { cluster: 'cluster4', source: 123, target: 22, value: 1, valueid: 'targetca', paperName: 'MVM17', process: 'MVM17_3', id: 'MVM17-6', imgUrl: 'U35x588.png', color: 'targetLinkFourColor' },
    { cluster: 'cluster4', source: 123, target: 23, value: 1, valueid: 'targetca', paperName: 'MVM17', process: 'MVM17_3', id: 'MVM17-7', imgUrl: 'U35x588.png', color: 'targetLinkFourColor' },
    { cluster: 'cluster4', source: 2, target: 46, value: 1, valueid: 'targetca', paperName: 'MVM17', process: 'MVM17_1', id: 'MVM17-8', imgUrl: 'U35x588.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 4, target: 46, value: 1, valueid: 'targetca', paperName: 'MVM17', process: 'MVM17_1', id: 'MVM17-9', imgUrl: 'U35x588.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 7, target: 46, value: 1, valueid: 'targetca', paperName: 'MVM17', process: 'MVM17_1', id: 'MVM17-10', imgUrl: 'U35x588.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 21, target: 46, value: 1, valueid: 'targetca', paperName: 'MVM17', process: 'MVM17_3', id: 'MVM17-18', imgUrl: 'U35x588.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 22, target: 46, value: 1, valueid: 'targetca', paperName: 'MVM17', process: 'MVM17_3', id: 'MVM17-19', imgUrl: 'U35x588.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 23, target: 46, value: 1, valueid: 'targetca', paperName: 'MVM17', process: 'MVM17_3', id: 'MVM17-20', imgUrl: 'U35x588.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 60, value: 1, valueid: 'targetca', paperName: 'MVM17', process: 'MVM17_1', id: 'MVM17-21', imgUrl: 'U35x588.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 60, value: 1, valueid: 'targetca', paperName: 'MVM17', process: 'MVM17_3', id: 'MVM17-22', imgUrl: 'U35x588.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 60, target: 77, value: 1, valueid: 'targetca', paperName: 'MVM17', process: 'MVM17_3', id: 'MVM17-26', imgUrl: 'U35x588.png', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 60, target: 79, value: 1, valueid: 'targetca', paperName: 'MVM17', process: 'MVM17_3', id: 'MVM17-32', imgUrl: 'U35x588.png', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 124, target: 23, value: 1, valueid: 'repg', paperName: 'MWSO08', process: 'MWSO08_3', id: 'MWSO08-2', imgUrl: 'ZplNAXx.jpg', color: 'targetLinkFourColor' },
    { cluster: 'cluster4', source: 23, target: 46, value: 1, valueid: 'repg', paperName: 'MWSO08', process: 'MWSO08_3', id: 'MWSO08-8', imgUrl: 'ZplNAXx.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 68, value: 1, valueid: 'repg', paperName: 'MWSO08', process: 'MWSO08_3', id: 'MWSO08-12', imgUrl: 'ZplNAXx.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 68, target: 77, value: 1, valueid: 'repg', paperName: 'MWSO08', process: 'MWSO08_3', id: 'MWSO08-15', imgUrl: 'ZplNAXx.jpg', color: 'repVisVarColor' },
    {
        cluster: 'cluster4',
        source: 127,
        target: 21,
        value: 1,
        valueid: ['targetcb', 'repf'],
        paperName: 'SCS16',
        process: 'SCS16_4',
        id: 'SCS16-3',
        imgUrl: 'ELyzRJL.jpg',
        color: 'targetLinkFourColor',
    },
    {
        cluster: 'cluster4',
        source: 127,
        target: 23,
        value: 1,
        valueid: ['targetcb', 'repf'],
        paperName: 'SCS16',
        process: 'SCS16_4',
        id: 'SCS16-4',
        imgUrl: 'ELyzRJL.jpg',
        color: 'targetLinkFourColor',
    },
    {
        cluster: 'cluster4',
        source: 127,
        target: 27,
        value: 1,
        valueid: ['targetcb', 'repf'],
        paperName: 'SCS16',
        process: 'SCS16_4',
        id: 'SCS16-5',
        imgUrl: 'ELyzRJL.jpg',
        color: 'targetLinkFourColor',
    },
    { cluster: 'cluster4', source: 21, target: 46, value: 1, valueid: ['targetcb', 'repa'], paperName: 'SCS16', process: 'SCS16_4', id: 'SCS16-32', imgUrl: 'ELyzRJL.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 23, target: 46, value: 1, valueid: ['targetcb', 'repa'], paperName: 'SCS16', process: 'SCS16_4', id: 'SCS16-33', imgUrl: 'ELyzRJL.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 27, target: 46, value: 1, valueid: ['targetcb', 'repa'], paperName: 'SCS16', process: 'SCS16_4', id: 'SCS16-34', imgUrl: 'ELyzRJL.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 75, value: 1, valueid: ['targetcb', 'repa'], paperName: 'SCS16', process: 'SCS16_4', id: 'SCS16-35', imgUrl: 'ELyzRJL.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 75, target: 98, value: 1, valueid: ['targetcb', 'repa'], paperName: 'SCS16', process: 'SCS16_4', id: 'SCS16-36', imgUrl: 'ELyzRJL.jpg', color: 'repVisTechColor' },
    {
        cluster: 'cluster4',
        source: 128,
        target: 11,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'SCS17',
        process: 'SCS17_2',
        id: 'SCS17-1',
        imgUrl: 'h29usSh.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 128,
        target: 23,
        value: 1,
        valueid: ['targetcb', 'repa'],
        paperName: 'SCS17',
        process: 'SCS17_5',
        id: 'SCS17-6',
        imgUrl: 'h29usSh.jpg',
        color: 'targetLinkFourColor',
    },
    {
        cluster: 'cluster4',
        source: 11,
        target: 46,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'SCS17',
        process: 'SCS17_2',
        id: 'SCS17-16',
        imgUrl: 'h29usSh.jpg',
        color: 'intFiveLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 46,
        target: 63,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'SCS17',
        process: 'SCS17_2',
        id: 'SCS17-19',
        imgUrl: 'h29usSh.jpg',
        color: 'intFiveLinkColor',
    },
    {
        cluster: 'cluster4',
        source: 63,
        target: 78,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'SCS17',
        process: 'SCS17_2',
        id: 'SCS17-20',
        imgUrl: 'h29usSh.jpg',
        color: 'repVisVarColor',
    },
    {
        cluster: 'cluster4',
        source: 63,
        target: 79,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'SCS17',
        process: 'SCS17_2',
        id: 'SCS17-21',
        imgUrl: 'h29usSh.jpg',
        color: 'repVisVarColor',
    },
    {
        cluster: 'cluster4',
        source: 63,
        target: 80,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'SCS17',
        process: 'SCS17_2',
        id: 'SCS17-22',
        imgUrl: 'h29usSh.jpg',
        color: 'repVisVarColor',
    },
    {
        cluster: 'cluster4',
        source: 63,
        target: 82,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'SCS17',
        process: 'SCS17_2',
        id: 'SCS17-23',
        imgUrl: 'h29usSh.jpg',
        color: 'repVisVarColor',
    },
    { cluster: 'cluster4', source: 23, target: 46, value: 1, valueid: ['targetcb', 'repa'], paperName: 'SCS17', process: 'SCS17_5', id: 'SCS17-34', imgUrl: 'h29usSh.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 63, value: 1, valueid: ['targetcb', 'repa'], paperName: 'SCS17', process: 'SCS17_5', id: 'SCS17-35', imgUrl: 'h29usSh.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 63, target: 77, value: 1, valueid: ['targetcb', 'repa'], paperName: 'SCS17', process: 'SCS17_5', id: 'SCS17-36', imgUrl: 'h29usSh.jpg', color: 'repVisVarColor' },
    {
        cluster: 'cluster4',
        source: 129,
        target: 11,
        value: 1,
        valueid: ['targetcb', 'repb'],
        paperName: 'SCS19',
        process: 'SCS19_3',
        id: 'SCS19-3',
        imgUrl: 'kl0Dozw.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 129,
        target: 18,
        value: 1,
        valueid: ['targetcb', 'repeb'],
        paperName: 'SCS19',
        process: 'SCS19_8',
        id: 'SCS19-9',
        imgUrl: 'kl0Dozw.jpg',
        color: 'targetLinkThreeColor',
    },
    {
        cluster: 'cluster4',
        source: 129,
        target: 18,
        value: 1,
        valueid: ['targetcb', 'repb'],
        paperName: 'SCS19',
        process: 'SCS19_9',
        id: 'SCS19-10',
        imgUrl: 'kl0Dozw.jpg',
        color: 'targetLinkThreeColor',
    },
    {
        cluster: 'cluster4',
        source: 129,
        target: 22,
        value: 1,
        valueid: ['targetcb', 'repa'],
        paperName: 'SCS19',
        process: 'SCS19_10',
        id: 'SCS19-11',
        imgUrl: 'kl0Dozw.jpg',
        color: 'targetLinkFourColor',
    },
    {
        cluster: 'cluster4',
        source: 129,
        target: 24,
        value: 1,
        valueid: ['targetcb', 'repa'],
        paperName: 'SCS19',
        process: 'SCS19_10',
        id: 'SCS19-12',
        imgUrl: 'kl0Dozw.jpg',
        color: 'targetLinkFourColor',
    },
    {
        cluster: 'cluster4',
        source: 129,
        target: 27,
        value: 1,
        valueid: ['targetcb', 'repa'],
        paperName: 'SCS19',
        process: 'SCS19_10',
        id: 'SCS19-13',
        imgUrl: 'kl0Dozw.jpg',
        color: 'targetLinkFourColor',
    },
    { cluster: 'cluster4', source: 11, target: 46, value: 1, valueid: ['targetcb', 'repb'], paperName: 'SCS19', process: 'SCS19_3', id: 'SCS19-23', imgUrl: 'kl0Dozw.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 54, value: 1, valueid: ['targetcb', 'repb'], paperName: 'SCS19', process: 'SCS19_3', id: 'SCS19-24', imgUrl: 'kl0Dozw.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 54, target: 78, value: 1, valueid: ['targetcb', 'repb'], paperName: 'SCS19', process: 'SCS19_3', id: 'SCS19-25', imgUrl: 'kl0Dozw.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 18, target: 46, value: 1, valueid: ['targetcb', 'repeb'], paperName: 'SCS19', process: 'SCS19_8', id: 'SCS19-39', imgUrl: 'kl0Dozw.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 59, value: 1, valueid: ['targetcb', 'repeb'], paperName: 'SCS19', process: 'SCS19_8', id: 'SCS19-40', imgUrl: 'kl0Dozw.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 59, target: 78, value: 1, valueid: ['targetcb', 'repeb'], paperName: 'SCS19', process: 'SCS19_8', id: 'SCS19-41', imgUrl: 'kl0Dozw.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 18, target: 46, value: 1, valueid: ['targetcb', 'repb'], paperName: 'SCS19', process: 'SCS19_9', id: 'SCS19-42', imgUrl: 'kl0Dozw.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 54, value: 1, valueid: ['targetcb', 'repb'], paperName: 'SCS19', process: 'SCS19_9', id: 'SCS19-43', imgUrl: 'kl0Dozw.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 54, target: 78, value: 1, valueid: ['targetcb', 'repb'], paperName: 'SCS19', process: 'SCS19_9', id: 'SCS19-44', imgUrl: 'kl0Dozw.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 22, target: 46, value: 1, valueid: ['targetcb', 'repa'], paperName: 'SCS19', process: 'SCS19_10', id: 'SCS19-45', imgUrl: 'kl0Dozw.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 24, target: 46, value: 1, valueid: ['targetcb', 'repa'], paperName: 'SCS19', process: 'SCS19_10', id: 'SCS19-46', imgUrl: 'kl0Dozw.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 27, target: 46, value: 1, valueid: ['targetcb', 'repa'], paperName: 'SCS19', process: 'SCS19_10', id: 'SCS19-47', imgUrl: 'kl0Dozw.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 73, value: 1, valueid: ['targetcb', 'repa'], paperName: 'SCS19', process: 'SCS19_10', id: 'SCS19-48', imgUrl: 'kl0Dozw.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 73, target: 98, value: 1, valueid: ['targetcb', 'repa'], paperName: 'SCS19', process: 'SCS19_10', id: 'SCS19-49', imgUrl: 'kl0Dozw.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 130, target: 23, value: 1, valueid: 'repf', paperName: 'SSK12', process: 'SSK12_2', id: 'SSK12-4', imgUrl: 'chAdr4B.png', color: 'targetLinkFourColor' },
    { cluster: 'cluster4', source: 130, target: 24, value: 1, valueid: 'repg', paperName: 'SSK12', process: 'SSK12_3', id: 'SSK12-5', imgUrl: 'chAdr4B.png', color: 'targetLinkFourColor' },
    { cluster: 'cluster4', source: 23, target: 46, value: 1, valueid: 'repf', paperName: 'SSK12', process: 'SSK12_2', id: 'SSK12-13', imgUrl: 'chAdr4B.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 60, value: 1, valueid: 'repf', paperName: 'SSK12', process: 'SSK12_2', id: 'SSK12-14', imgUrl: 'chAdr4B.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 60, target: 77, value: 1, valueid: 'repf', paperName: 'SSK12', process: 'SSK12_2', id: 'SSK12-15', imgUrl: 'chAdr4B.png', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 60, target: 80, value: 1, valueid: 'repf', paperName: 'SSK12', process: 'SSK12_2', id: 'SSK12-16', imgUrl: 'chAdr4B.png', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 60, target: 81, value: 1, valueid: 'repf', paperName: 'SSK12', process: 'SSK12_2', id: 'SSK12-17', imgUrl: 'chAdr4B.png', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 24, target: 46, value: 1, valueid: 'repg', paperName: 'SSK12', process: 'SSK12_3', id: 'SSK12-18', imgUrl: 'chAdr4B.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 68, value: 1, valueid: 'repg', paperName: 'SSK12', process: 'SSK12_3', id: 'SSK12-19', imgUrl: 'chAdr4B.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 68, target: 98, value: 1, valueid: 'repg', paperName: 'SSK12', process: 'SSK12_3', id: 'SSK12-20', imgUrl: 'chAdr4B.png', color: 'repVisTechColor' },
    {
        cluster: 'cluster4',
        source: 131,
        target: 11,
        value: 1,
        valueid: ['targetcb', 'repc'],
        paperName: 'VWH13',
        process: 'VWH13_1',
        id: 'VWH13-0',
        imgUrl: 'TO07ZUT.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 131,
        target: 12,
        value: 1,
        valueid: ['targetcb', 'repc'],
        paperName: 'VWH13',
        process: 'VWH13_1',
        id: 'VWH13-1',
        imgUrl: 'TO07ZUT.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 131,
        target: 14,
        value: 1,
        valueid: ['targetcb', 'repc'],
        paperName: 'VWH13',
        process: 'VWH13_1',
        id: 'VWH13-2',
        imgUrl: 'TO07ZUT.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 131,
        target: 15,
        value: 1,
        valueid: ['targetcb', 'repc'],
        paperName: 'VWH13',
        process: 'VWH13_1',
        id: 'VWH13-3',
        imgUrl: 'TO07ZUT.jpg',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 131,
        target: 21,
        value: 1,
        valueid: ['targetcb', 'repc'],
        paperName: 'VWH13',
        process: 'VWH13_3',
        id: 'VWH13-5',
        imgUrl: 'TO07ZUT.jpg',
        color: 'targetLinkFourColor',
    },
    {
        cluster: 'cluster4',
        source: 131,
        target: 23,
        value: 1,
        valueid: ['targetcb', 'repc'],
        paperName: 'VWH13',
        process: 'VWH13_3',
        id: 'VWH13-6',
        imgUrl: 'TO07ZUT.jpg',
        color: 'targetLinkFourColor',
    },

    {
        cluster: 'cluster4',
        source: 131,
        target: 23,
        value: 1,
        valueid: ['targetcb', 'repf'],
        paperName: 'VWH13',
        process: 'VWH13_4',
        id: 'VWH13-8',
        imgUrl: 'TO07ZUT.jpg',
        color: 'targetLinkFourColor',
    },
    { cluster: 'cluster4', source: 11, target: 46, value: 1, valueid: ['targetcb', 'repc'], paperName: 'VWH13', process: 'VWH13_1', id: 'VWH13-13', imgUrl: 'TO07ZUT.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 12, target: 46, value: 1, valueid: ['targetcb', 'repc'], paperName: 'VWH13', process: 'VWH13_1', id: 'VWH13-14', imgUrl: 'TO07ZUT.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 14, target: 46, value: 1, valueid: ['targetcb', 'repc'], paperName: 'VWH13', process: 'VWH13_1', id: 'VWH13-15', imgUrl: 'TO07ZUT.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 15, target: 46, value: 1, valueid: ['targetcb', 'repc'], paperName: 'VWH13', process: 'VWH13_1', id: 'VWH13-16', imgUrl: 'TO07ZUT.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 53, value: 1, valueid: ['targetcb', 'repc'], paperName: 'VWH13', process: 'VWH13_1', id: 'VWH13-18', imgUrl: 'TO07ZUT.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 53, target: 77, value: 1, valueid: ['targetcb', 'repc'], paperName: 'VWH13', process: 'VWH13_1', id: 'VWH13-19', imgUrl: 'TO07ZUT.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 21, target: 46, value: 1, valueid: ['targetcb', 'repc'], paperName: 'VWH13', process: 'VWH13_3', id: 'VWH13-25', imgUrl: 'TO07ZUT.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 23, target: 46, value: 1, valueid: ['targetcb', 'repc'], paperName: 'VWH13', process: 'VWH13_3', id: 'VWH13-28', imgUrl: 'TO07ZUT.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 53, value: 1, valueid: ['targetcb', 'repc'], paperName: 'VWH13', process: 'VWH13_3', id: 'VWH13-31', imgUrl: 'TO07ZUT.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 53, target: 78, value: 1, valueid: ['targetcb', 'repc'], paperName: 'VWH13', process: 'VWH13_3', id: 'VWH13-35', imgUrl: 'TO07ZUT.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 21, target: 46, value: 1, valueid: ['targetcb', 'repf'], paperName: 'VWH13', process: 'VWH13_4', id: 'VWH13-36', imgUrl: 'TO07ZUT.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 23, target: 46, value: 1, valueid: ['targetcb', 'repf'], paperName: 'VWH13', process: 'VWH13_4', id: 'VWH13-37', imgUrl: 'TO07ZUT.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 60, value: 1, valueid: ['targetcb', 'repf'], paperName: 'VWH13', process: 'VWH13_4', id: 'VWH13-42', imgUrl: 'TO07ZUT.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 132, target: 22, value: 1, valueid: ['targetcb', 'repc'], paperName: 'XD99', process: ' XD99_4', id: 'XD99-3', imgUrl: 'CaBMwKE.jpg', color: 'targetLinkFourColor' },
    { cluster: 'cluster4', source: 132, target: 22, value: 1, valueid: ['targetcb', 'repc'], paperName: 'XD99', process: ' XD99_5', id: 'XD99-4', imgUrl: 'CaBMwKE.jpg', color: 'targetLinkFourColor' },
    { cluster: 'cluster4', source: 132, target: 23, value: 1, valueid: ['targetcb', 'repc'], paperName: 'XD99', process: ' XD99_6', id: 'XD99-5', imgUrl: 'CaBMwKE.jpg', color: 'targetLinkFourColor' },
    { cluster: 'cluster4', source: 22, target: 46, value: 1, valueid: ['targetcb', 'repc'], paperName: 'XD99', process: ' XD99_4', id: 'XD99-8', imgUrl: 'CaBMwKE.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 22, target: 46, value: 1, valueid: ['targetcb', 'repc'], paperName: 'XD99', process: ' XD99_5', id: 'XD99-9', imgUrl: 'CaBMwKE.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 23, target: 46, value: 1, valueid: ['targetcb', 'repc'], paperName: 'XD99', process: ' XD99_6', id: 'XD99-10', imgUrl: 'CaBMwKE.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 53, value: 1, valueid: ['targetcb', 'repc'], paperName: 'XD99', process: ' XD99_5', id: 'XD99-16', imgUrl: 'CaBMwKE.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 70, value: 1, valueid: ['targetcb', 'repc'], paperName: 'XD99', process: ' XD99_4', id: 'XD99-18', imgUrl: 'CaBMwKE.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 70, value: 1, valueid: ['targetcb', 'repc'], paperName: 'XD99', process: ' XD99_6', id: 'XD99-19', imgUrl: 'CaBMwKE.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 70, target: 78, value: 1, valueid: ['targetcb', 'repc'], paperName: 'XD99', process: ' XD99_4', id: 'XD99-22', imgUrl: 'CaBMwKE.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 53, target: 79, value: 1, valueid: ['targetcb', 'repc'], paperName: 'XD99', process: ' XD99_5', id: 'XD99-23', imgUrl: 'CaBMwKE.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 70, target: 98, value: 1, valueid: ['targetcb', 'repc'], paperName: 'XD99', process: ' XD99_6', id: 'XD99-24', imgUrl: 'CaBMwKE.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 134, target: 21, value: 1, valueid: 'repc', paperName: 'XWS16', process: 'XWS16_7', id: 'XWS16-6', imgUrl: 'xn5MqwV.jpg', color: 'targetLinkFourColor' },
    { cluster: 'cluster4', source: 134, target: 23, value: 1, valueid: 'repc', paperName: 'XWS16', process: 'XWS16_7', id: 'XWS16-7', imgUrl: 'xn5MqwV.jpg', color: 'targetLinkFourColor' },
    { cluster: 'cluster4', source: 21, target: 46, value: 1, valueid: 'repc', paperName: 'XWS16', process: 'XWS16_7', id: 'XWS16-14', imgUrl: 'xn5MqwV.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 23, target: 46, value: 1, valueid: 'repc', paperName: 'XWS16', process: 'XWS16_7', id: 'XWS16-15', imgUrl: 'xn5MqwV.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 135, target: 24, value: 1, valueid: 'repf', paperName: 'YFS10', process: 'YFS10_5', id: 'YFS10-26', imgUrl: 'A14dGOk.png', color: 'targetLinkFourColor' },
    { cluster: 'cluster4', source: 24, target: 46, value: 1, valueid: 'repf', paperName: 'YFS10', process: 'YFS10_5', id: 'YFS10-27', imgUrl: 'A14dGOk.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 60, value: 1, valueid: 'repf', paperName: 'YFS10', process: 'YFS10_5', id: 'YFS10-28', imgUrl: 'A14dGOk.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 60, target: 98, value: 1, valueid: 'repf', paperName: 'YFS10', process: 'YFS10_5', id: 'YFS10-29', imgUrl: 'A14dGOk.png', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 139, target: 11, value: 1, valueid: 'targetbb', paperName: 'RSRY12', process: 'RSRY12_2', id: 'RSRY12-1', imgUrl: 'ivVW2HN.png', color: 'targetLinkTwoColor' },
    { cluster: 'cluster4', source: 11, target: 46, value: 1, valueid: 'targetbb', paperName: 'RSRY12', process: 'RSRY12_2', id: 'RSRY12-5', imgUrl: 'ivVW2HN.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 24, target: 46, value: 1, valueid: 'targetbb', paperName: 'RSRY12', process: 'RSRY12_3', id: 'RSRY12-7', imgUrl: 'ivVW2HN.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 70, value: 1, valueid: 'targetbb', paperName: 'RSRY12', process: 'RSRY12_2', id: 'RSRY12-10', imgUrl: 'ivVW2HN.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 70, target: 88, value: 1, valueid: 'targetbb', paperName: 'RSRY12', process: 'RSRY12_2', id: 'RSRY12-16', imgUrl: 'ivVW2HN.png', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 140, target: 24, value: 1, valueid: 'targetca', paperName: 'FAKM15', process: 'FAKM15_3', id: 'FAKM15-13', imgUrl: 'u2sWSNe.jpg', color: 'targetLinkFourColor' },
    { cluster: 'cluster4', source: 24, target: 46, value: 1, valueid: 'targetca', paperName: 'FAKM15', process: 'FAKM15_3', id: 'FAKM15-14', imgUrl: 'u2sWSNe.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 75, value: 1, valueid: 'targetca', paperName: 'FAKM15', process: 'FAKM15_3', id: 'FAKM15-16', imgUrl: 'u2sWSNe.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 75, target: 88, value: 1, valueid: 'targetca', paperName: 'FAKM15', process: 'FAKM15_3', id: 'FAKM15-18', imgUrl: 'u2sWSNe.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 75, target: 98, value: 1, valueid: 'targetca', paperName: 'FAKM15', process: 'FAKM15_3', id: 'FAKM15-19', imgUrl: 'u2sWSNe.jpg', color: 'repVisTechColor' },
    {
        cluster: 'cluster4',
        source: 141,
        target: 22,
        value: 1,
        valueid: ['targetcb', 'reph'],
        paperName: 'YSK14',
        process: 'YSK14_6',
        id: 'YSK14-4',
        imgUrl: 'sBwMjs9.png',
        color: 'targetLinkFourColor',
    },
    { cluster: 'cluster4', source: 24, target: 46, value: 1, valueid: ['targetcb', 'repb'], paperName: 'YSK14', process: 'YSK14_5', id: 'YSK14-11', imgUrl: 'sBwMjs9.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 24, target: 46, value: 1, valueid: ['targetcb', 'repb'], paperName: 'YSK14', process: 'YSK14_7', id: 'YSK14-12', imgUrl: 'sBwMjs9.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 22, target: 46, value: 1, valueid: ['targetcb', 'reph'], paperName: 'YSK14', process: 'YSK14_6', id: 'YSK14-13', imgUrl: 'sBwMjs9.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 54, value: 1, valueid: ['targetcb', 'repb'], paperName: 'YSK14', process: 'YSK14_5', id: 'YSK14-16', imgUrl: 'sBwMjs9.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 62, value: 1, valueid: ['targetcb', 'reph'], paperName: 'YSK14', process: 'YSK14_6', id: 'YSK14-17', imgUrl: 'sBwMjs9.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 70, value: 1, valueid: ['targetcb', 'repb'], paperName: 'YSK14', process: 'YSK14_7', id: 'YSK14-18', imgUrl: 'sBwMjs9.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 54, target: 78, value: 1, valueid: ['targetcb', 'repb'], paperName: 'YSK14', process: 'YSK14_5', id: 'YSK14-22', imgUrl: 'sBwMjs9.png', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 62, target: 76, value: 1, valueid: ['targetcb', 'reph'], paperName: 'YSK14', process: 'YSK14_6', id: 'YSK14-24', imgUrl: 'sBwMjs9.png', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 54, target: 98, value: 1, valueid: ['targetcb', 'repb'], paperName: 'YSK14', process: 'YSK14_5', id: 'YSK14-29', imgUrl: 'sBwMjs9.png', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 62, target: 98, value: 1, valueid: ['targetcb', 'reph'], paperName: 'YSK14', process: 'YSK14_6', id: 'YSK14-30', imgUrl: 'sBwMjs9.png', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 70, target: 98, value: 1, valueid: ['targetcb', 'repb'], paperName: 'YSK14', process: 'YSK14_7', id: 'YSK14-31', imgUrl: 'sBwMjs9.png', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 142, target: 23, value: 1, valueid: 'repd', paperName: 'CSL16', process: 'CSL16_6', id: 'CSL16-7', imgUrl: 'mt871Nx.png', color: 'targetLinkFourColor' },
    { cluster: 'cluster4', source: 142, target: 28, value: 1, valueid: 'repd', paperName: 'CSL16', process: 'CSL16_6', id: 'CSL16-8', imgUrl: 'mt871Nx.png', color: 'targetLinkFourColor' },
    { cluster: 'cluster4', source: 23, target: 46, value: 1, valueid: 'repd', paperName: 'CSL16', process: 'CSL16_6', id: 'CSL16-29', imgUrl: 'mt871Nx.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 28, target: 46, value: 1, valueid: 'repd', paperName: 'CSL16', process: 'CSL16_6', id: 'CSL16-30', imgUrl: 'mt871Nx.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 70, value: 1, valueid: 'repd', paperName: 'CSL16', process: 'CSL16_6', id: 'CSL16-31', imgUrl: 'mt871Nx.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 70, target: 98, value: 1, valueid: 'repd', paperName: 'CSL16', process: 'CSL16_6', id: 'CSL16-32', imgUrl: 'mt871Nx.png', color: 'repVisTechColor' },
    {
        cluster: 'cluster4',
        source: 143,
        target: 21,
        value: 1,
        valueid: ['targetbb', 'repf'],
        paperName: 'RRR19',
        process: 'RRR19_4',
        id: 'RRR19-7',
        imgUrl: 'yya8s2u.png',
        color: 'targetLinkFourColor',
    },
    {
        cluster: 'cluster4',
        source: 143,
        target: 12,
        value: 1,
        valueid: ['targetbb', 'repf'],
        paperName: 'RRR19',
        process: 'RRR19_5',
        id: 'RRR19-8',
        imgUrl: 'yya8s2u.png',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 143,
        target: 14,
        value: 1,
        valueid: ['targetbb', 'repf'],
        paperName: 'RRR19',
        process: 'RRR19_5',
        id: 'RRR19-9',
        imgUrl: 'yya8s2u.png',
        color: 'targetLinkTwoColor',
    },
    {
        cluster: 'cluster4',
        source: 143,
        target: 15,
        value: 1,
        valueid: ['targetbb', 'repf'],
        paperName: 'RRR19',
        process: 'RRR19_5',
        id: 'RRR19-10',
        imgUrl: 'yya8s2u.png',
        color: 'targetLinkTwoColor',
    },
    { cluster: 'cluster4', source: 21, target: 46, value: 1, valueid: ['targetbb', 'repf'], paperName: 'RRR19', process: 'RRR19_4', id: 'RRR19-27', imgUrl: 'yya8s2u.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 75, value: 1, valueid: ['targetbb', 'repf'], paperName: 'RRR19', process: 'RRR19_4', id: 'RRR19-28', imgUrl: 'yya8s2u.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 75, target: 77, value: 1, valueid: ['targetbb', 'repf'], paperName: 'RRR19', process: 'RRR19_4', id: 'RRR19-29', imgUrl: 'yya8s2u.png', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 75, target: 98, value: 1, valueid: ['targetbb', 'repf'], paperName: 'RRR19', process: 'RRR19_4', id: 'RRR19-30', imgUrl: 'yya8s2u.png', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 12, target: 46, value: 1, valueid: ['targetbb', 'repf'], paperName: 'RRR19', process: 'RRR19_5', id: 'RRR19-31', imgUrl: 'yya8s2u.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 14, target: 46, value: 1, valueid: ['targetbb', 'repf'], paperName: 'RRR19', process: 'RRR19_5', id: 'RRR19-32', imgUrl: 'yya8s2u.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 15, target: 46, value: 1, valueid: ['targetbb', 'repf'], paperName: 'RRR19', process: 'RRR19_5', id: 'RRR19-33', imgUrl: 'yya8s2u.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 60, value: 1, valueid: ['targetbb', 'repf'], paperName: 'RRR19', process: 'RRR19_5', id: 'RRR19-34', imgUrl: 'yya8s2u.png', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 60, target: 77, value: 1, valueid: ['targetbb', 'repf'], paperName: 'RRR19', process: 'RRR19_5', id: 'RRR19-35', imgUrl: 'yya8s2u.png', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 60, target: 98, value: 1, valueid: ['targetbb', 'repf'], paperName: 'RRR19', process: 'RRR19_5', id: 'RRR19-36', imgUrl: 'yya8s2u.png', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 145, target: 23, value: 1, valueid: 'repb', paperName: 'MDDD16', process: 'MDDD16_5', id: 'MDDD16-6', imgUrl: '4teJby0.jpg', color: 'targetLinkFourColor' },
    { cluster: 'cluster4', source: 23, target: 46, value: 1, valueid: 'repb', paperName: 'MDDD16', process: 'MDDD16_5', id: 'MDDD16-13', imgUrl: '4teJby0.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 70, value: 1, valueid: 'repb', paperName: 'GYS14', process: 'GYS14_8', id: 'GYS14-20', imgUrl: 'r9tEkOr.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 70, target: 98, value: 1, valueid: 'repb', paperName: 'GYS14', process: 'GYS14_8', id: 'GYS14-46', imgUrl: 'r9tEkOr.jpg', color: 'repVisTechColor' },
    { cluster: 'cluster4', source: 147, target: 23, value: 1, valueid: 'repf', paperName: 'MDJW07', process: 'MDJW07_9', id: 'MDJW07-9', imgUrl: 'E21AFdm.jpg', color: 'targetLinkFourColor' },
    { cluster: 'cluster4', source: 147, target: 23, value: 1, valueid: 'repf', paperName: 'MDJW07', process: 'MDJW07_10', id: 'MDJW07-10', imgUrl: 'E21AFdm.jpg', color: 'targetLinkFourColor' },
    { cluster: 'cluster4', source: 23, target: 46, value: 1, valueid: 'repf', paperName: 'MDJW07', process: 'MDJW07_9', id: 'MDJW07-20', imgUrl: 'E21AFdm.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 23, target: 46, value: 1, valueid: 'repf', paperName: 'MDJW07', process: 'MDJW07_10', id: 'MDJW07-21', imgUrl: 'E21AFdm.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 155, target: 23, value: 1, valueid: 'repb', paperName: 'DJM12', process: 'DJM12_9', id: 'DJM12-8', imgUrl: 'nNNbNas.jpg', color: 'targetLinkFourColor' },
    { cluster: 'cluster4', source: 23, target: 46, value: 1, valueid: 'repb', paperName: 'DJM12', process: 'DJM12_9', id: 'DJM12-17', imgUrl: 'nNNbNas.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 157, target: 5, value: 1, valueid: ['targetaa', 'repb'], paperName: 'SFJ16', process: 'SFJ16_2', id: 'SFJ16-4', imgUrl: 'e3PRKTM.jpg', color: 'targetLinkColor' },
    {
        cluster: 'cluster4',
        source: 157,
        target: 22,
        value: 1,
        valueid: ['targetaa', 'repb'],
        paperName: 'SFJ16',
        process: 'SFJ16_2',
        id: 'SFJ16-5',
        imgUrl: 'e3PRKTM.jpg',
        color: 'targetLinkFourColor',
    },
    { cluster: 'cluster4', source: 5, target: 46, value: 1, valueid: ['targetaa', 'repb'], paperName: 'SFJ16', process: 'SFJ16_2', id: 'SFJ16-16', imgUrl: 'e3PRKTM.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 22, target: 46, value: 1, valueid: ['targetaa', 'repb'], paperName: 'SFJ16', process: 'SFJ16_2', id: 'SFJ16-17', imgUrl: 'e3PRKTM.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 46, target: 54, value: 1, valueid: ['targetaa', 'repb'], paperName: 'SFJ16', process: 'SFJ16_2', id: 'SFJ16-18', imgUrl: 'e3PRKTM.jpg', color: 'intFiveLinkColor' },
    { cluster: 'cluster4', source: 54, target: 76, value: 1, valueid: ['targetaa', 'repb'], paperName: 'SFJ16', process: 'SFJ16_2', id: 'SFJ16-19', imgUrl: 'e3PRKTM.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 54, target: 77, value: 1, valueid: ['targetaa', 'repb'], paperName: 'SFJ16', process: 'SFJ16_2', id: 'SFJ16-20', imgUrl: 'e3PRKTM.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 54, target: 79, value: 1, valueid: ['targetaa', 'repb'], paperName: 'SFJ16', process: 'SFJ16_2', id: 'SFJ16-21', imgUrl: 'e3PRKTM.jpg', color: 'repVisVarColor' },
    { cluster: 'cluster4', source: 54, target: 98, value: 1, valueid: ['targetaa', 'repb'], paperName: 'SFJ16', process: 'SFJ16_2', id: 'SFJ16-22', imgUrl: 'e3PRKTM.jpg', color: 'repVisTechColor' },
];
